unit ContractImportSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, VCL.TMSFNCCustomControl,
  VCL.TMSFNCDataGrid, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.DBCtrls,
  Vcl.Controls, WEBLib.ExtCtrls, Data.DB, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCDataGridDatabaseAdapter, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client, WEBLib.Buttons, WEBLib.WebCtrls,
  WEBLib.XLSX, Types, Vcl.Grids, WEBLib.Grids;

type
  TfrmImportSetup = class(TForm)
    WebPanel6: TPanel;
    WebPanel18: TPanel;
    WebGroupBox8: TGroupBox;
    WebDBLabel1: TDBLabel;
    WebDBLabel2: TDBLabel;
    WebLabel45: TLabel;
    WebButton37: TButton;
    WebGroupBox9: TGroupBox;
    WebLabel43: TLabel;
    WebLabel44: TLabel;
    WebButton38: TButton;
    WebDBEdit55: TDBEdit;
    WebDBEdit56: TDBEdit;
    WebButton40: TButton;
    WebButton41: TButton;
    WebPanel19: TPanel;
    WebLabel46: TLabel;
    WebLabel47: TLabel;
    WebLabel48: TLabel;
    WebLabel49: TLabel;
    WebLabel50: TLabel;
    WebLabel51: TLabel;
    WebLabel52: TLabel;
    WebLabel53: TLabel;
    edtSortOrder: TDBEdit;
    edtColumnNo: TDBEdit;
    edtDisplayFormat: TDBEdit;
    edtStartCopy: TDBEdit;
    edtEndCopy: TDBEdit;
    edtCharEnding: TDBEdit;
    edtFieldName: TDBEdit;
    WebPanel20: TPanel;
    wcImportSetup: TXDataWebClient;
    wdsImportSetup: TXDataWebDataSet;
    dsImportSetup: TDataSource;
    wdsImportSetupAUTONO: TIntegerField;
    wdsImportSetupCONTRACTNO: TIntegerField;
    wdsImportSetupSORTORDER: TIntegerField;
    wdsImportSetupCOLNO: TIntegerField;
    wdsImportSetupFIELDNAME: TStringField;
    wdsImportSetupFIELDTYPE: TStringField;
    wdsImportSetupFORMATDISPLAY: TStringField;
    wdsImportSetupSTARTCOPY: TIntegerField;
    wdsImportSetupENDCOPY: TIntegerField;
    wdsImportSetupCHAREND: TStringField;
    wdsImportSetupIMPORTTYPE: TIntegerField;
    wdsImportSetupDEB_CODE: TStringField;
    wdsImportSetupIMPORTTYPEREC: TIntegerField;
    TMSFNCDataGrid2: TTMSFNCDataGrid;
    dgdbaImportSetup: TTMSFNCDataGridDatabaseAdapter;
    wdsDisplay: TXDataWebDataSet;
    dsDisplay: TDataSource;
    wcDisplay: TXDataWebClient;
    wdsDisplayDEB_NAME: TStringField;
    wdsDisplayCONTRACTNAME: TStringField;
    btnFirst: TSpeedButton;
    btnPrior: TSpeedButton;
    btnNext: TSpeedButton;
    btnLast: TSpeedButton;
    btnInsert: TSpeedButton;
    btnSearchFieldName: TButton;
    btnSaveSetup: TSpeedButton;
    btnCancelSetup: TSpeedButton;
    cbbDataType: TDBComboBox;
    WebFilePicker1: TFilePicker;
    WebXLSX1: TXLSX;
    WebStringGrid1: TStringGrid;
    dsInsertImportSetup: TDataSource;
    wdsContract: TXDataWebDataSet;
    IntegerField32: TIntegerField;
    StringField94: TStringField;
    StringField95: TStringField;
    IntegerField33: TIntegerField;
    IntegerField34: TIntegerField;
    IntegerField35: TIntegerField;
    IntegerField36: TIntegerField;
    IntegerField37: TIntegerField;
    IntegerField38: TIntegerField;
    IntegerField39: TIntegerField;
    IntegerField40: TIntegerField;
    IntegerField41: TIntegerField;
    StringField96: TStringField;
    StringField97: TStringField;
    FloatField17: TFloatField;
    FloatField18: TFloatField;
    FloatField19: TFloatField;
    FloatField20: TFloatField;
    FloatField21: TFloatField;
    StringField98: TStringField;
    StringField99: TStringField;
    FloatField22: TFloatField;
    IntegerField42: TIntegerField;
    IntegerField43: TIntegerField;
    IntegerField44: TIntegerField;
    IntegerField45: TIntegerField;
    IntegerField46: TIntegerField;
    IntegerField47: TIntegerField;
    IntegerField48: TIntegerField;
    StringField100: TStringField;
    StringField101: TStringField;
    StringField102: TStringField;
    StringField103: TStringField;
    StringField104: TStringField;
    StringField105: TStringField;
    StringField106: TStringField;
    StringField107: TStringField;
    StringField108: TStringField;
    FloatField23: TFloatField;
    SmallintField4: TSmallintField;
    SmallintField5: TSmallintField;
    IntegerField49: TIntegerField;
    SmallintField6: TSmallintField;
    IntegerField50: TIntegerField;
    StringField109: TStringField;
    StringField110: TStringField;
    StringField111: TStringField;
    StringField112: TStringField;
    StringField113: TStringField;
    StringField114: TStringField;
    StringField115: TStringField;
    StringField116: TStringField;
    StringField117: TStringField;
    StringField118: TStringField;
    IntegerField51: TIntegerField;
    StringField119: TStringField;
    IntegerField52: TIntegerField;
    FloatField24: TFloatField;
    StringField120: TStringField;
    StringField121: TStringField;
    StringField122: TStringField;
    StringField123: TStringField;
    StringField124: TStringField;
    StringField125: TStringField;
    StringField126: TStringField;
    StringField127: TStringField;
    StringField128: TStringField;
    IntegerField53: TIntegerField;
    StringField129: TStringField;
    StringField130: TStringField;
    StringField131: TStringField;
    StringField132: TStringField;
    StringField133: TStringField;
    StringField134: TStringField;
    StringField135: TStringField;
    StringField136: TStringField;
    IntegerField54: TIntegerField;
    StringField137: TStringField;
    StringField138: TStringField;
    StringField139: TStringField;
    StringField140: TStringField;
    StringField141: TStringField;
    StringField142: TStringField;
    StringField143: TStringField;
    FloatField25: TFloatField;
    StringField144: TStringField;
    StringField145: TStringField;
    StringField146: TStringField;
    StringField147: TStringField;
    StringField148: TStringField;
    TimeField2: TTimeField;
    IntegerField55: TIntegerField;
    IntegerField56: TIntegerField;
    IntegerField57: TIntegerField;
    DateField4: TDateField;
    DateField5: TDateField;
    DateField6: TDateField;
    StringField149: TStringField;
    StringField150: TStringField;
    StringField151: TStringField;
    FloatField26: TFloatField;
    FloatField27: TFloatField;
    FloatField28: TFloatField;
    FloatField29: TFloatField;
    StringField152: TStringField;
    StringField153: TStringField;
    StringField154: TStringField;
    StringField155: TStringField;
    StringField156: TStringField;
    StringField157: TStringField;
    StringField158: TStringField;
    StringField159: TStringField;
    FloatField30: TFloatField;
    StringField160: TStringField;
    StringField161: TStringField;
    StringField162: TStringField;
    StringField163: TStringField;
    StringField164: TStringField;
    FloatField31: TFloatField;
    StringField165: TStringField;
    StringField166: TStringField;
    StringField167: TStringField;
    StringField168: TStringField;
    StringField169: TStringField;
    StringField170: TStringField;
    StringField171: TStringField;
    IntegerField58: TIntegerField;
    StringField172: TStringField;
    StringField173: TStringField;
    StringField174: TStringField;
    StringField175: TStringField;
    StringField176: TStringField;
    IntegerField59: TIntegerField;
    StringField177: TStringField;
    StringField178: TStringField;
    StringField179: TStringField;
    StringField180: TStringField;
    IntegerField60: TIntegerField;
    StringField181: TStringField;
    StringField182: TStringField;
    StringField183: TStringField;
    IntegerField61: TIntegerField;
    StringField184: TStringField;
    StringField185: TStringField;
    IntegerField62: TIntegerField;
    StringField186: TStringField;
    FloatField32: TFloatField;
    StringField187: TStringField;
    StringField188: TStringField;
    StringField189: TStringField;
    StringField190: TStringField;
    StringField191: TStringField;
    StringField192: TStringField;
    StringField193: TStringField;
    StringField194: TStringField;
    StringField195: TStringField;
    StringField196: TStringField;
    StringField197: TStringField;
    StringField198: TStringField;
    IntegerField63: TIntegerField;
    StringField199: TStringField;
    wcContract: TXDataWebClient;
    dsContracts: TDataSource;
    wdsInsertImportSetup: TXDataWebDataSet;
    wdsInsertImportSetupAUTONO: TIntegerField;
    wdsInsertImportSetupCONTRACTNO: TIntegerField;
    wdsInsertImportSetupSORTORDER: TIntegerField;
    wdsInsertImportSetupCOLNO: TIntegerField;
    wdsInsertImportSetupFIELDNAME: TStringField;
    wdsInsertImportSetupFIELDTYPE: TStringField;
    wdsInsertImportSetupFORMATDISPLAY: TStringField;
    wdsInsertImportSetupSTARTCOPY: TIntegerField;
    wdsInsertImportSetupENDCOPY: TIntegerField;
    wdsInsertImportSetupCHAREND: TStringField;
    wdsInsertImportSetupIMPORTTYPE: TIntegerField;
    wdsInsertImportSetupDEB_CODE: TStringField;
    wdsInsertImportSetupIMPORTTYPEREC: TIntegerField;
    WebSpeedButton1: TSpeedButton;
    edtTemp: TLabel;
    procedure WebFormShow(Sender: TObject);
    procedure WebButton37Click(Sender: TObject);
    procedure btnInsertClick(Sender: TObject);
    procedure btnSaveSetupClick(Sender: TObject);
    procedure btnCancelSetupClick(Sender: TObject);
    procedure WebFilePicker1Change(Sender: TObject);
    procedure WebFilePicker1GetFileAsArrayBuffer(Sender: TObject;
      AFileIndex: Integer; ABuffer: TJSArrayBufferRecord);
  private
    { Private declarations }

    procedure loadImportSetup(iPageCount, iContractNo, iImportTypeRec, iImportType: Integer);
    procedure LoadContract;

    procedure addImport(bSetup : boolean);
  public
    { Public declarations }

    PageCount, ContractNo, ImportTypeRec, ImportType: Integer;
  protected procedure LoadDFMValues; override; end;

var
  frmImportSetup: TfrmImportSetup;

implementation

{$R *.dfm}

uses
  stfmssystem.connection,share.classes,share.common;

{ TfrmImportSetup }

procedure TfrmImportSetup.addImport(bSetup: boolean);
begin
  btnFirst.Enabled := NOT bSetup;
  btnPrior.Enabled := NOT bSetup;
  btnNext.Enabled := NOT bSetup;
  btnLast.Enabled := NOT bSetup;
  btnInsert.Enabled := NOT bSetup;

  btnSaveSetup.Enabled := bSetup;
  btnCancelSetup.Enabled := bSetup;

  edtSortOrder.Enabled := bSetup;
  edtColumnNo.Enabled := bSetup;
  edtDisplayFormat.Enabled := bSetup;
  edtStartCopy.Enabled := bSetup;
  edtEndCopy.Enabled := bSetup;
  edtCharEnding.Enabled := bSetup;
  edtFieldName.Enabled := bSetup;
  cbbDataType.Enabled := bSetup;

  btnSearchFieldName.Enabled := NOT bSetup;
end;

procedure TfrmImportSetup.loadImportSetup(iPageCount, iContractNo, iImportTypeRec,
  iImportType: Integer);
var
  sJson : String;

  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
      loadImportSetup(iPageCount, iContractNo, iImportTypeRec,iImportType);
    end;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      wdsImportSetup.Close;
      wdsImportSetup.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsImportSetup.Open;
    end;

begin

  sJson := '{"PageCount":' + IntToStr(iPageCount) + ',"ContractNo":' + IntToStr(iContractNo) + ',"ImportTypeRec":' + IntToStr(iImportTypeRec) + ',"ImportType":' + IntToStr(iImportType) + '}';

  wcImportSetup.RawInvoke('IstfmsloadsService.Get_ImportSetup_View',[sJson],@OnSuccess,@OnError);
end;

procedure TfrmImportSetup.WebButton37Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmImportSetup.WebFilePicker1Change(Sender: TObject);

begin
  if WebFilePicker1.Files.Count = 0 then
    Exit;

    WebFilePicker1.Files[0].GetFileAsArrayBuffer;

end;

procedure TfrmImportSetup.WebFilePicker1GetFileAsArrayBuffer(Sender: TObject;
  AFileIndex: Integer; ABuffer: TJSArrayBufferRecord);

begin

    WebXLSX1.Load(ABuffer);  // This is the correct way to load the XLSX file!

    //Handle Completion in OnWorkbookLoaded Event
end;

procedure TfrmImportSetup.WebFormShow(Sender: TObject);


begin

  edtTemp.Caption := IntToStr(ContractNo);
  LoadContract;
  loadImportSetup(-1, ContractNo, ImportTypeRec,ImportType);
end;

procedure TfrmImportSetup.btnCancelSetupClick(Sender: TObject);
begin
  addImport(False);
end;

procedure TfrmImportSetup.btnInsertClick(Sender: TObject);
begin
  addImport(True);
  wdsInsertImportSetup.Open;
  wdsInsertImportSetup.Insert;

end;

procedure TfrmImportSetup.btnSaveSetupClick(Sender: TObject);
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      ShowMessage('Import Setup Successfully Saved');
      loadImportSetup(-1, ContractNo, ImportTypeRec,ImportType);
      addImport(False);
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);

    end;
begin
  wdsInsertImportSetup.FieldByName('DEB_CODE').AsString := wdsContract.FieldByName('DEB_CODE').AsString;
  wdsInsertImportSetup.FieldByName('CONTRACTNO').AsInteger := ContractNo;

  wcImportSetup.RawInvoke('IstfmsloadsService.ImportSetup_Insert',[GetJsonFromDataSet(wdsInsertImportSetup)],@OnSuccess,@OnError);
  console.log(GetJsonFromDataSet(wdsInsertImportSetup));


end;

procedure TfrmImportSetup.LoadContract;
var
  ContractsParams : TContractsParams;
  paramsJson : String;

  procedure OnResult(Response : TXDataClientResponse);
    begin

      wdsContract.Close;
      wdsContract.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsContract.Open;

      console.log(GetJsonFromDataSet(wdsContract));
      ContractsParams.Free;

    end;
begin
  ContractsParams := TContractsParams.Create;
  ContractsParams.SearchContract := '*';
  ContractsParams.Completed := 'N';                   {"ContractNo":-1,"SearchContract":"*","Completed":"N","PageCount":1}
  ContractsParams.ContractNo := ContractNo;
  ContractsParams.PageCount := -1;

  ParamsJSON :=  ConvertObjToJson(ContractsParams).ToJSON;

  wcContract.RawInvoke('IstfmsloadsService.Get_AContract_View',[ParamsJSON],@OnResult);
end;

procedure TfrmImportSetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel6 := TPanel.Create(Self);
  WebPanel18 := TPanel.Create(Self);
  WebGroupBox8 := TGroupBox.Create(Self);
  WebDBLabel1 := TDBLabel.Create(Self);
  WebDBLabel2 := TDBLabel.Create(Self);
  WebLabel45 := TLabel.Create(Self);
  edtTemp := TLabel.Create(Self);
  WebButton37 := TButton.Create(Self);
  WebGroupBox9 := TGroupBox.Create(Self);
  WebLabel43 := TLabel.Create(Self);
  WebLabel44 := TLabel.Create(Self);
  WebButton38 := TButton.Create(Self);
  WebDBEdit55 := TDBEdit.Create(Self);
  WebDBEdit56 := TDBEdit.Create(Self);
  WebButton40 := TButton.Create(Self);
  WebButton41 := TButton.Create(Self);
  WebFilePicker1 := TFilePicker.Create(Self);
  WebStringGrid1 := TStringGrid.Create(Self);
  WebPanel19 := TPanel.Create(Self);
  WebLabel46 := TLabel.Create(Self);
  WebLabel47 := TLabel.Create(Self);
  WebLabel48 := TLabel.Create(Self);
  WebLabel49 := TLabel.Create(Self);
  WebLabel50 := TLabel.Create(Self);
  WebLabel51 := TLabel.Create(Self);
  WebLabel52 := TLabel.Create(Self);
  WebLabel53 := TLabel.Create(Self);
  edtSortOrder := TDBEdit.Create(Self);
  edtColumnNo := TDBEdit.Create(Self);
  edtDisplayFormat := TDBEdit.Create(Self);
  edtStartCopy := TDBEdit.Create(Self);
  edtEndCopy := TDBEdit.Create(Self);
  edtCharEnding := TDBEdit.Create(Self);
  edtFieldName := TDBEdit.Create(Self);
  WebPanel20 := TPanel.Create(Self);
  TMSFNCDataGrid2 := TTMSFNCDataGrid.Create(Self);
  dgdbaImportSetup := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  btnFirst := TSpeedButton.Create(Self);
  btnPrior := TSpeedButton.Create(Self);
  btnNext := TSpeedButton.Create(Self);
  btnLast := TSpeedButton.Create(Self);
  btnInsert := TSpeedButton.Create(Self);
  btnSearchFieldName := TButton.Create(Self);
  btnSaveSetup := TSpeedButton.Create(Self);
  btnCancelSetup := TSpeedButton.Create(Self);
  cbbDataType := TDBComboBox.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  wcImportSetup := TXDataWebClient.Create(Self);
  wdsImportSetup := TXDataWebDataSet.Create(Self);
  wdsImportSetupAUTONO := TIntegerField.Create(Self);
  wdsImportSetupCONTRACTNO := TIntegerField.Create(Self);
  wdsImportSetupSORTORDER := TIntegerField.Create(Self);
  wdsImportSetupCOLNO := TIntegerField.Create(Self);
  wdsImportSetupFIELDNAME := TStringField.Create(Self);
  wdsImportSetupFIELDTYPE := TStringField.Create(Self);
  wdsImportSetupFORMATDISPLAY := TStringField.Create(Self);
  wdsImportSetupSTARTCOPY := TIntegerField.Create(Self);
  wdsImportSetupENDCOPY := TIntegerField.Create(Self);
  wdsImportSetupCHAREND := TStringField.Create(Self);
  wdsImportSetupIMPORTTYPE := TIntegerField.Create(Self);
  wdsImportSetupDEB_CODE := TStringField.Create(Self);
  wdsImportSetupIMPORTTYPEREC := TIntegerField.Create(Self);
  dsImportSetup := TDataSource.Create(Self);
  wdsDisplay := TXDataWebDataSet.Create(Self);
  wdsDisplayDEB_NAME := TStringField.Create(Self);
  wdsDisplayCONTRACTNAME := TStringField.Create(Self);
  dsDisplay := TDataSource.Create(Self);
  wcDisplay := TXDataWebClient.Create(Self);
  WebXLSX1 := TXLSX.Create(Self);
  dsInsertImportSetup := TDataSource.Create(Self);
  wdsContract := TXDataWebDataSet.Create(Self);
  IntegerField32 := TIntegerField.Create(Self);
  StringField94 := TStringField.Create(Self);
  StringField95 := TStringField.Create(Self);
  IntegerField33 := TIntegerField.Create(Self);
  IntegerField34 := TIntegerField.Create(Self);
  IntegerField35 := TIntegerField.Create(Self);
  IntegerField36 := TIntegerField.Create(Self);
  IntegerField37 := TIntegerField.Create(Self);
  IntegerField38 := TIntegerField.Create(Self);
  IntegerField39 := TIntegerField.Create(Self);
  IntegerField40 := TIntegerField.Create(Self);
  IntegerField41 := TIntegerField.Create(Self);
  StringField96 := TStringField.Create(Self);
  StringField97 := TStringField.Create(Self);
  FloatField17 := TFloatField.Create(Self);
  FloatField18 := TFloatField.Create(Self);
  FloatField19 := TFloatField.Create(Self);
  FloatField20 := TFloatField.Create(Self);
  FloatField21 := TFloatField.Create(Self);
  StringField98 := TStringField.Create(Self);
  StringField99 := TStringField.Create(Self);
  FloatField22 := TFloatField.Create(Self);
  IntegerField42 := TIntegerField.Create(Self);
  IntegerField43 := TIntegerField.Create(Self);
  IntegerField44 := TIntegerField.Create(Self);
  IntegerField45 := TIntegerField.Create(Self);
  IntegerField46 := TIntegerField.Create(Self);
  IntegerField47 := TIntegerField.Create(Self);
  IntegerField48 := TIntegerField.Create(Self);
  StringField100 := TStringField.Create(Self);
  StringField101 := TStringField.Create(Self);
  StringField102 := TStringField.Create(Self);
  StringField103 := TStringField.Create(Self);
  StringField104 := TStringField.Create(Self);
  StringField105 := TStringField.Create(Self);
  StringField106 := TStringField.Create(Self);
  StringField107 := TStringField.Create(Self);
  StringField108 := TStringField.Create(Self);
  FloatField23 := TFloatField.Create(Self);
  SmallintField4 := TSmallintField.Create(Self);
  SmallintField5 := TSmallintField.Create(Self);
  IntegerField49 := TIntegerField.Create(Self);
  SmallintField6 := TSmallintField.Create(Self);
  IntegerField50 := TIntegerField.Create(Self);
  StringField109 := TStringField.Create(Self);
  StringField110 := TStringField.Create(Self);
  StringField111 := TStringField.Create(Self);
  StringField112 := TStringField.Create(Self);
  StringField113 := TStringField.Create(Self);
  StringField114 := TStringField.Create(Self);
  StringField115 := TStringField.Create(Self);
  StringField116 := TStringField.Create(Self);
  StringField117 := TStringField.Create(Self);
  StringField118 := TStringField.Create(Self);
  IntegerField51 := TIntegerField.Create(Self);
  StringField119 := TStringField.Create(Self);
  IntegerField52 := TIntegerField.Create(Self);
  FloatField24 := TFloatField.Create(Self);
  StringField120 := TStringField.Create(Self);
  StringField121 := TStringField.Create(Self);
  StringField122 := TStringField.Create(Self);
  StringField123 := TStringField.Create(Self);
  StringField124 := TStringField.Create(Self);
  StringField125 := TStringField.Create(Self);
  StringField126 := TStringField.Create(Self);
  StringField127 := TStringField.Create(Self);
  StringField128 := TStringField.Create(Self);
  IntegerField53 := TIntegerField.Create(Self);
  StringField129 := TStringField.Create(Self);
  StringField130 := TStringField.Create(Self);
  StringField131 := TStringField.Create(Self);
  StringField132 := TStringField.Create(Self);
  StringField133 := TStringField.Create(Self);
  StringField134 := TStringField.Create(Self);
  StringField135 := TStringField.Create(Self);
  StringField136 := TStringField.Create(Self);
  IntegerField54 := TIntegerField.Create(Self);
  StringField137 := TStringField.Create(Self);
  StringField138 := TStringField.Create(Self);
  StringField139 := TStringField.Create(Self);
  StringField140 := TStringField.Create(Self);
  StringField141 := TStringField.Create(Self);
  StringField142 := TStringField.Create(Self);
  StringField143 := TStringField.Create(Self);
  FloatField25 := TFloatField.Create(Self);
  StringField144 := TStringField.Create(Self);
  StringField145 := TStringField.Create(Self);
  StringField146 := TStringField.Create(Self);
  StringField147 := TStringField.Create(Self);
  StringField148 := TStringField.Create(Self);
  TimeField2 := TTimeField.Create(Self);
  IntegerField55 := TIntegerField.Create(Self);
  IntegerField56 := TIntegerField.Create(Self);
  IntegerField57 := TIntegerField.Create(Self);
  DateField4 := TDateField.Create(Self);
  DateField5 := TDateField.Create(Self);
  DateField6 := TDateField.Create(Self);
  StringField149 := TStringField.Create(Self);
  StringField150 := TStringField.Create(Self);
  StringField151 := TStringField.Create(Self);
  FloatField26 := TFloatField.Create(Self);
  FloatField27 := TFloatField.Create(Self);
  FloatField28 := TFloatField.Create(Self);
  FloatField29 := TFloatField.Create(Self);
  StringField152 := TStringField.Create(Self);
  StringField153 := TStringField.Create(Self);
  StringField154 := TStringField.Create(Self);
  StringField155 := TStringField.Create(Self);
  StringField156 := TStringField.Create(Self);
  StringField157 := TStringField.Create(Self);
  StringField158 := TStringField.Create(Self);
  StringField159 := TStringField.Create(Self);
  FloatField30 := TFloatField.Create(Self);
  StringField160 := TStringField.Create(Self);
  StringField161 := TStringField.Create(Self);
  StringField162 := TStringField.Create(Self);
  StringField163 := TStringField.Create(Self);
  StringField164 := TStringField.Create(Self);
  FloatField31 := TFloatField.Create(Self);
  StringField165 := TStringField.Create(Self);
  StringField166 := TStringField.Create(Self);
  StringField167 := TStringField.Create(Self);
  StringField168 := TStringField.Create(Self);
  StringField169 := TStringField.Create(Self);
  StringField170 := TStringField.Create(Self);
  StringField171 := TStringField.Create(Self);
  IntegerField58 := TIntegerField.Create(Self);
  StringField172 := TStringField.Create(Self);
  StringField173 := TStringField.Create(Self);
  StringField174 := TStringField.Create(Self);
  StringField175 := TStringField.Create(Self);
  StringField176 := TStringField.Create(Self);
  IntegerField59 := TIntegerField.Create(Self);
  StringField177 := TStringField.Create(Self);
  StringField178 := TStringField.Create(Self);
  StringField179 := TStringField.Create(Self);
  StringField180 := TStringField.Create(Self);
  IntegerField60 := TIntegerField.Create(Self);
  StringField181 := TStringField.Create(Self);
  StringField182 := TStringField.Create(Self);
  StringField183 := TStringField.Create(Self);
  IntegerField61 := TIntegerField.Create(Self);
  StringField184 := TStringField.Create(Self);
  StringField185 := TStringField.Create(Self);
  IntegerField62 := TIntegerField.Create(Self);
  StringField186 := TStringField.Create(Self);
  FloatField32 := TFloatField.Create(Self);
  StringField187 := TStringField.Create(Self);
  StringField188 := TStringField.Create(Self);
  StringField189 := TStringField.Create(Self);
  StringField190 := TStringField.Create(Self);
  StringField191 := TStringField.Create(Self);
  StringField192 := TStringField.Create(Self);
  StringField193 := TStringField.Create(Self);
  StringField194 := TStringField.Create(Self);
  StringField195 := TStringField.Create(Self);
  StringField196 := TStringField.Create(Self);
  StringField197 := TStringField.Create(Self);
  StringField198 := TStringField.Create(Self);
  IntegerField63 := TIntegerField.Create(Self);
  StringField199 := TStringField.Create(Self);
  wcContract := TXDataWebClient.Create(Self);
  dsContracts := TDataSource.Create(Self);
  wdsInsertImportSetup := TXDataWebDataSet.Create(Self);
  wdsInsertImportSetupAUTONO := TIntegerField.Create(Self);
  wdsInsertImportSetupCONTRACTNO := TIntegerField.Create(Self);
  wdsInsertImportSetupSORTORDER := TIntegerField.Create(Self);
  wdsInsertImportSetupCOLNO := TIntegerField.Create(Self);
  wdsInsertImportSetupFIELDNAME := TStringField.Create(Self);
  wdsInsertImportSetupFIELDTYPE := TStringField.Create(Self);
  wdsInsertImportSetupFORMATDISPLAY := TStringField.Create(Self);
  wdsInsertImportSetupSTARTCOPY := TIntegerField.Create(Self);
  wdsInsertImportSetupENDCOPY := TIntegerField.Create(Self);
  wdsInsertImportSetupCHAREND := TStringField.Create(Self);
  wdsInsertImportSetupIMPORTTYPE := TIntegerField.Create(Self);
  wdsInsertImportSetupDEB_CODE := TStringField.Create(Self);
  wdsInsertImportSetupIMPORTTYPEREC := TIntegerField.Create(Self);

  WebPanel6.BeforeLoadDFMValues;
  WebPanel18.BeforeLoadDFMValues;
  WebGroupBox8.BeforeLoadDFMValues;
  WebDBLabel1.BeforeLoadDFMValues;
  WebDBLabel2.BeforeLoadDFMValues;
  WebLabel45.BeforeLoadDFMValues;
  edtTemp.BeforeLoadDFMValues;
  WebButton37.BeforeLoadDFMValues;
  WebGroupBox9.BeforeLoadDFMValues;
  WebLabel43.BeforeLoadDFMValues;
  WebLabel44.BeforeLoadDFMValues;
  WebButton38.BeforeLoadDFMValues;
  WebDBEdit55.BeforeLoadDFMValues;
  WebDBEdit56.BeforeLoadDFMValues;
  WebButton40.BeforeLoadDFMValues;
  WebButton41.BeforeLoadDFMValues;
  WebFilePicker1.BeforeLoadDFMValues;
  WebStringGrid1.BeforeLoadDFMValues;
  WebPanel19.BeforeLoadDFMValues;
  WebLabel46.BeforeLoadDFMValues;
  WebLabel47.BeforeLoadDFMValues;
  WebLabel48.BeforeLoadDFMValues;
  WebLabel49.BeforeLoadDFMValues;
  WebLabel50.BeforeLoadDFMValues;
  WebLabel51.BeforeLoadDFMValues;
  WebLabel52.BeforeLoadDFMValues;
  WebLabel53.BeforeLoadDFMValues;
  edtSortOrder.BeforeLoadDFMValues;
  edtColumnNo.BeforeLoadDFMValues;
  edtDisplayFormat.BeforeLoadDFMValues;
  edtStartCopy.BeforeLoadDFMValues;
  edtEndCopy.BeforeLoadDFMValues;
  edtCharEnding.BeforeLoadDFMValues;
  edtFieldName.BeforeLoadDFMValues;
  WebPanel20.BeforeLoadDFMValues;
  TMSFNCDataGrid2.BeforeLoadDFMValues;
  dgdbaImportSetup.BeforeLoadDFMValues;
  btnFirst.BeforeLoadDFMValues;
  btnPrior.BeforeLoadDFMValues;
  btnNext.BeforeLoadDFMValues;
  btnLast.BeforeLoadDFMValues;
  btnInsert.BeforeLoadDFMValues;
  btnSearchFieldName.BeforeLoadDFMValues;
  btnSaveSetup.BeforeLoadDFMValues;
  btnCancelSetup.BeforeLoadDFMValues;
  cbbDataType.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  wcImportSetup.BeforeLoadDFMValues;
  wdsImportSetup.BeforeLoadDFMValues;
  wdsImportSetupAUTONO.BeforeLoadDFMValues;
  wdsImportSetupCONTRACTNO.BeforeLoadDFMValues;
  wdsImportSetupSORTORDER.BeforeLoadDFMValues;
  wdsImportSetupCOLNO.BeforeLoadDFMValues;
  wdsImportSetupFIELDNAME.BeforeLoadDFMValues;
  wdsImportSetupFIELDTYPE.BeforeLoadDFMValues;
  wdsImportSetupFORMATDISPLAY.BeforeLoadDFMValues;
  wdsImportSetupSTARTCOPY.BeforeLoadDFMValues;
  wdsImportSetupENDCOPY.BeforeLoadDFMValues;
  wdsImportSetupCHAREND.BeforeLoadDFMValues;
  wdsImportSetupIMPORTTYPE.BeforeLoadDFMValues;
  wdsImportSetupDEB_CODE.BeforeLoadDFMValues;
  wdsImportSetupIMPORTTYPEREC.BeforeLoadDFMValues;
  dsImportSetup.BeforeLoadDFMValues;
  wdsDisplay.BeforeLoadDFMValues;
  wdsDisplayDEB_NAME.BeforeLoadDFMValues;
  wdsDisplayCONTRACTNAME.BeforeLoadDFMValues;
  dsDisplay.BeforeLoadDFMValues;
  wcDisplay.BeforeLoadDFMValues;
  WebXLSX1.BeforeLoadDFMValues;
  dsInsertImportSetup.BeforeLoadDFMValues;
  wdsContract.BeforeLoadDFMValues;
  IntegerField32.BeforeLoadDFMValues;
  StringField94.BeforeLoadDFMValues;
  StringField95.BeforeLoadDFMValues;
  IntegerField33.BeforeLoadDFMValues;
  IntegerField34.BeforeLoadDFMValues;
  IntegerField35.BeforeLoadDFMValues;
  IntegerField36.BeforeLoadDFMValues;
  IntegerField37.BeforeLoadDFMValues;
  IntegerField38.BeforeLoadDFMValues;
  IntegerField39.BeforeLoadDFMValues;
  IntegerField40.BeforeLoadDFMValues;
  IntegerField41.BeforeLoadDFMValues;
  StringField96.BeforeLoadDFMValues;
  StringField97.BeforeLoadDFMValues;
  FloatField17.BeforeLoadDFMValues;
  FloatField18.BeforeLoadDFMValues;
  FloatField19.BeforeLoadDFMValues;
  FloatField20.BeforeLoadDFMValues;
  FloatField21.BeforeLoadDFMValues;
  StringField98.BeforeLoadDFMValues;
  StringField99.BeforeLoadDFMValues;
  FloatField22.BeforeLoadDFMValues;
  IntegerField42.BeforeLoadDFMValues;
  IntegerField43.BeforeLoadDFMValues;
  IntegerField44.BeforeLoadDFMValues;
  IntegerField45.BeforeLoadDFMValues;
  IntegerField46.BeforeLoadDFMValues;
  IntegerField47.BeforeLoadDFMValues;
  IntegerField48.BeforeLoadDFMValues;
  StringField100.BeforeLoadDFMValues;
  StringField101.BeforeLoadDFMValues;
  StringField102.BeforeLoadDFMValues;
  StringField103.BeforeLoadDFMValues;
  StringField104.BeforeLoadDFMValues;
  StringField105.BeforeLoadDFMValues;
  StringField106.BeforeLoadDFMValues;
  StringField107.BeforeLoadDFMValues;
  StringField108.BeforeLoadDFMValues;
  FloatField23.BeforeLoadDFMValues;
  SmallintField4.BeforeLoadDFMValues;
  SmallintField5.BeforeLoadDFMValues;
  IntegerField49.BeforeLoadDFMValues;
  SmallintField6.BeforeLoadDFMValues;
  IntegerField50.BeforeLoadDFMValues;
  StringField109.BeforeLoadDFMValues;
  StringField110.BeforeLoadDFMValues;
  StringField111.BeforeLoadDFMValues;
  StringField112.BeforeLoadDFMValues;
  StringField113.BeforeLoadDFMValues;
  StringField114.BeforeLoadDFMValues;
  StringField115.BeforeLoadDFMValues;
  StringField116.BeforeLoadDFMValues;
  StringField117.BeforeLoadDFMValues;
  StringField118.BeforeLoadDFMValues;
  IntegerField51.BeforeLoadDFMValues;
  StringField119.BeforeLoadDFMValues;
  IntegerField52.BeforeLoadDFMValues;
  FloatField24.BeforeLoadDFMValues;
  StringField120.BeforeLoadDFMValues;
  StringField121.BeforeLoadDFMValues;
  StringField122.BeforeLoadDFMValues;
  StringField123.BeforeLoadDFMValues;
  StringField124.BeforeLoadDFMValues;
  StringField125.BeforeLoadDFMValues;
  StringField126.BeforeLoadDFMValues;
  StringField127.BeforeLoadDFMValues;
  StringField128.BeforeLoadDFMValues;
  IntegerField53.BeforeLoadDFMValues;
  StringField129.BeforeLoadDFMValues;
  StringField130.BeforeLoadDFMValues;
  StringField131.BeforeLoadDFMValues;
  StringField132.BeforeLoadDFMValues;
  StringField133.BeforeLoadDFMValues;
  StringField134.BeforeLoadDFMValues;
  StringField135.BeforeLoadDFMValues;
  StringField136.BeforeLoadDFMValues;
  IntegerField54.BeforeLoadDFMValues;
  StringField137.BeforeLoadDFMValues;
  StringField138.BeforeLoadDFMValues;
  StringField139.BeforeLoadDFMValues;
  StringField140.BeforeLoadDFMValues;
  StringField141.BeforeLoadDFMValues;
  StringField142.BeforeLoadDFMValues;
  StringField143.BeforeLoadDFMValues;
  FloatField25.BeforeLoadDFMValues;
  StringField144.BeforeLoadDFMValues;
  StringField145.BeforeLoadDFMValues;
  StringField146.BeforeLoadDFMValues;
  StringField147.BeforeLoadDFMValues;
  StringField148.BeforeLoadDFMValues;
  TimeField2.BeforeLoadDFMValues;
  IntegerField55.BeforeLoadDFMValues;
  IntegerField56.BeforeLoadDFMValues;
  IntegerField57.BeforeLoadDFMValues;
  DateField4.BeforeLoadDFMValues;
  DateField5.BeforeLoadDFMValues;
  DateField6.BeforeLoadDFMValues;
  StringField149.BeforeLoadDFMValues;
  StringField150.BeforeLoadDFMValues;
  StringField151.BeforeLoadDFMValues;
  FloatField26.BeforeLoadDFMValues;
  FloatField27.BeforeLoadDFMValues;
  FloatField28.BeforeLoadDFMValues;
  FloatField29.BeforeLoadDFMValues;
  StringField152.BeforeLoadDFMValues;
  StringField153.BeforeLoadDFMValues;
  StringField154.BeforeLoadDFMValues;
  StringField155.BeforeLoadDFMValues;
  StringField156.BeforeLoadDFMValues;
  StringField157.BeforeLoadDFMValues;
  StringField158.BeforeLoadDFMValues;
  StringField159.BeforeLoadDFMValues;
  FloatField30.BeforeLoadDFMValues;
  StringField160.BeforeLoadDFMValues;
  StringField161.BeforeLoadDFMValues;
  StringField162.BeforeLoadDFMValues;
  StringField163.BeforeLoadDFMValues;
  StringField164.BeforeLoadDFMValues;
  FloatField31.BeforeLoadDFMValues;
  StringField165.BeforeLoadDFMValues;
  StringField166.BeforeLoadDFMValues;
  StringField167.BeforeLoadDFMValues;
  StringField168.BeforeLoadDFMValues;
  StringField169.BeforeLoadDFMValues;
  StringField170.BeforeLoadDFMValues;
  StringField171.BeforeLoadDFMValues;
  IntegerField58.BeforeLoadDFMValues;
  StringField172.BeforeLoadDFMValues;
  StringField173.BeforeLoadDFMValues;
  StringField174.BeforeLoadDFMValues;
  StringField175.BeforeLoadDFMValues;
  StringField176.BeforeLoadDFMValues;
  IntegerField59.BeforeLoadDFMValues;
  StringField177.BeforeLoadDFMValues;
  StringField178.BeforeLoadDFMValues;
  StringField179.BeforeLoadDFMValues;
  StringField180.BeforeLoadDFMValues;
  IntegerField60.BeforeLoadDFMValues;
  StringField181.BeforeLoadDFMValues;
  StringField182.BeforeLoadDFMValues;
  StringField183.BeforeLoadDFMValues;
  IntegerField61.BeforeLoadDFMValues;
  StringField184.BeforeLoadDFMValues;
  StringField185.BeforeLoadDFMValues;
  IntegerField62.BeforeLoadDFMValues;
  StringField186.BeforeLoadDFMValues;
  FloatField32.BeforeLoadDFMValues;
  StringField187.BeforeLoadDFMValues;
  StringField188.BeforeLoadDFMValues;
  StringField189.BeforeLoadDFMValues;
  StringField190.BeforeLoadDFMValues;
  StringField191.BeforeLoadDFMValues;
  StringField192.BeforeLoadDFMValues;
  StringField193.BeforeLoadDFMValues;
  StringField194.BeforeLoadDFMValues;
  StringField195.BeforeLoadDFMValues;
  StringField196.BeforeLoadDFMValues;
  StringField197.BeforeLoadDFMValues;
  StringField198.BeforeLoadDFMValues;
  IntegerField63.BeforeLoadDFMValues;
  StringField199.BeforeLoadDFMValues;
  wcContract.BeforeLoadDFMValues;
  dsContracts.BeforeLoadDFMValues;
  wdsInsertImportSetup.BeforeLoadDFMValues;
  wdsInsertImportSetupAUTONO.BeforeLoadDFMValues;
  wdsInsertImportSetupCONTRACTNO.BeforeLoadDFMValues;
  wdsInsertImportSetupSORTORDER.BeforeLoadDFMValues;
  wdsInsertImportSetupCOLNO.BeforeLoadDFMValues;
  wdsInsertImportSetupFIELDNAME.BeforeLoadDFMValues;
  wdsInsertImportSetupFIELDTYPE.BeforeLoadDFMValues;
  wdsInsertImportSetupFORMATDISPLAY.BeforeLoadDFMValues;
  wdsInsertImportSetupSTARTCOPY.BeforeLoadDFMValues;
  wdsInsertImportSetupENDCOPY.BeforeLoadDFMValues;
  wdsInsertImportSetupCHAREND.BeforeLoadDFMValues;
  wdsInsertImportSetupIMPORTTYPE.BeforeLoadDFMValues;
  wdsInsertImportSetupDEB_CODE.BeforeLoadDFMValues;
  wdsInsertImportSetupIMPORTTYPEREC.BeforeLoadDFMValues;
  try
    Name := 'frmImportSetup';
    Width := 1138;
    Height := 640;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel6.SetParentComponent(Self);
    WebPanel6.Name := 'WebPanel6';
    WebPanel6.Left := 0;
    WebPanel6.Top := 0;
    WebPanel6.Width := 1138;
    WebPanel6.Height := 640;
    WebPanel6.Align := alClient;
    WebPanel6.TabOrder := 0;
    WebPanel18.SetParentComponent(WebPanel6);
    WebPanel18.Name := 'WebPanel18';
    WebPanel18.Left := 0;
    WebPanel18.Top := 0;
    WebPanel18.Width := 1138;
    WebPanel18.Height := 270;
    WebPanel18.Align := alTop;
    WebPanel18.TabOrder := 0;
    WebGroupBox8.SetParentComponent(WebPanel18);
    WebGroupBox8.Name := 'WebGroupBox8';
    WebGroupBox8.Left := 0;
    WebGroupBox8.Top := 0;
    WebGroupBox8.Width := 1138;
    WebGroupBox8.Height := 64;
    WebGroupBox8.Align := alTop;
    WebGroupBox8.BorderColor := clSilver;
    WebGroupBox8.Caption := 'Contract Information';
    WebDBLabel1.SetParentComponent(WebGroupBox8);
    WebDBLabel1.Name := 'WebDBLabel1';
    WebDBLabel1.Left := 40;
    WebDBLabel1.Top := 24;
    WebDBLabel1.Width := 73;
    WebDBLabel1.Height := 15;
    WebDBLabel1.Caption := 'WebDBLabel1';
    WebDBLabel1.HeightPercent := 100.000000000000000000;
    WebDBLabel1.WidthPercent := 100.000000000000000000;
    WebDBLabel1.DataField := 'DEB_NAME';
    WebDBLabel1.DataSource := dsContracts;
    WebDBLabel2.SetParentComponent(WebGroupBox8);
    WebDBLabel2.Name := 'WebDBLabel2';
    WebDBLabel2.Left := 416;
    WebDBLabel2.Top := 24;
    WebDBLabel2.Width := 73;
    WebDBLabel2.Height := 15;
    WebDBLabel2.Caption := 'WebDBLabel2';
    WebDBLabel2.HeightPercent := 100.000000000000000000;
    WebDBLabel2.WidthPercent := 100.000000000000000000;
    WebDBLabel2.DataField := 'CONTRACTNAME';
    WebDBLabel2.DataSource := dsContracts;
    WebLabel45.SetParentComponent(WebGroupBox8);
    WebLabel45.Name := 'WebLabel45';
    WebLabel45.Left := 733;
    WebLabel45.Top := 23;
    WebLabel45.Width := 64;
    WebLabel45.Height := 15;
    WebLabel45.Caption := 'WebLabel45';
    WebLabel45.HeightPercent := 100.000000000000000000;
    WebLabel45.WidthPercent := 100.000000000000000000;
    edtTemp.SetParentComponent(WebGroupBox8);
    edtTemp.Name := 'edtTemp';
    edtTemp.Left := 552;
    edtTemp.Top := 32;
    edtTemp.Width := 47;
    edtTemp.Height := 15;
    edtTemp.Caption := 'edtTemp';
    edtTemp.HeightPercent := 100.000000000000000000;
    edtTemp.WidthPercent := 100.000000000000000000;
    WebButton37.SetParentComponent(WebGroupBox8);
    WebButton37.Name := 'WebButton37';
    WebButton37.Left := 1009;
    WebButton37.Top := 20;
    WebButton37.Width := 96;
    WebButton37.Height := 37;
    WebButton37.Caption := 'Back';
    WebButton37.Color := clRed;
    WebButton37.ChildOrder := 3;
    WebButton37.HeightPercent := 100.000000000000000000;
    WebButton37.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton37, Self, 'OnClick', 'WebButton37Click');
    WebGroupBox9.SetParentComponent(WebPanel18);
    WebGroupBox9.Name := 'WebGroupBox9';
    WebGroupBox9.Left := 0;
    WebGroupBox9.Top := 64;
    WebGroupBox9.Width := 1138;
    WebGroupBox9.Height := 66;
    WebGroupBox9.Align := alTop;
    WebGroupBox9.BorderColor := clSilver;
    WebGroupBox9.Caption := 'Excel File Information';
    WebGroupBox9.ChildOrder := 1;
    WebLabel43.SetParentComponent(WebGroupBox9);
    WebLabel43.Name := 'WebLabel43';
    WebLabel43.Left := 608;
    WebLabel43.Top := 16;
    WebLabel43.Width := 67;
    WebLabel43.Height := 15;
    WebLabel43.Caption := 'Import Type:';
    WebLabel43.HeightPercent := 100.000000000000000000;
    WebLabel43.WidthPercent := 100.000000000000000000;
    WebLabel44.SetParentComponent(WebGroupBox9);
    WebLabel44.Name := 'WebLabel44';
    WebLabel44.Left := 250;
    WebLabel44.Top := 13;
    WebLabel44.Width := 66;
    WebLabel44.Height := 15;
    WebLabel44.Caption := 'Select Sheet:';
    WebLabel44.HeightPercent := 100.000000000000000000;
    WebLabel44.WidthPercent := 100.000000000000000000;
    WebButton38.SetParentComponent(WebGroupBox9);
    WebButton38.Name := 'WebButton38';
    WebButton38.Left := 1009;
    WebButton38.Top := 18;
    WebButton38.Width := 96;
    WebButton38.Height := 37;
    WebButton38.Caption := 'Copy Setup';
    WebButton38.Color := clWhite;
    WebButton38.ChildOrder := 2;
    WebButton38.HeightPercent := 100.000000000000000000;
    WebButton38.WidthPercent := 100.000000000000000000;
    WebDBEdit55.SetParentComponent(WebGroupBox9);
    WebDBEdit55.Name := 'WebDBEdit55';
    WebDBEdit55.Left := 250;
    WebDBEdit55.Top := 32;
    WebDBEdit55.Width := 220;
    WebDBEdit55.Height := 22;
    WebDBEdit55.ChildOrder := 4;
    WebDBEdit55.HeightPercent := 100.000000000000000000;
    WebDBEdit55.Text := 'WebDBEdit55';
    WebDBEdit55.WidthPercent := 100.000000000000000000;
    WebDBEdit56.SetParentComponent(WebGroupBox9);
    WebDBEdit56.Name := 'WebDBEdit56';
    WebDBEdit56.Left := 608;
    WebDBEdit56.Top := 32;
    WebDBEdit56.Width := 220;
    WebDBEdit56.Height := 22;
    WebDBEdit56.ChildOrder := 5;
    WebDBEdit56.HeightPercent := 100.000000000000000000;
    WebDBEdit56.Text := 'WebDBEdit56';
    WebDBEdit56.WidthPercent := 100.000000000000000000;
    WebButton40.SetParentComponent(WebGroupBox9);
    WebButton40.Name := 'WebButton40';
    WebButton40.Left := 834;
    WebButton40.Top := 30;
    WebButton40.Width := 25;
    WebButton40.Height := 25;
    WebButton40.Caption := '...';
    WebButton40.ChildOrder := 6;
    WebButton40.HeightPercent := 100.000000000000000000;
    WebButton40.WidthPercent := 100.000000000000000000;
    WebButton41.SetParentComponent(WebGroupBox9);
    WebButton41.Name := 'WebButton41';
    WebButton41.Left := 480;
    WebButton41.Top := 31;
    WebButton41.Width := 25;
    WebButton41.Height := 25;
    WebButton41.Caption := '...';
    WebButton41.ChildOrder := 7;
    WebButton41.HeightPercent := 100.000000000000000000;
    WebButton41.WidthPercent := 100.000000000000000000;
    WebFilePicker1.SetParentComponent(WebGroupBox9);
    WebFilePicker1.Name := 'WebFilePicker1';
    WebFilePicker1.Left := 40;
    WebFilePicker1.Top := 23;
    WebFilePicker1.Width := 86;
    WebFilePicker1.Height := 37;
    WebFilePicker1.ChildOrder := 1;
    SetEvent(WebFilePicker1, Self, 'OnChange', 'WebFilePicker1Change');
    SetEvent(WebFilePicker1, Self, 'OnGetFileAsArrayBuffer', 'WebFilePicker1GetFileAsArrayBuffer');
    WebStringGrid1.SetParentComponent(WebPanel18);
    WebStringGrid1.Name := 'WebStringGrid1';
    WebStringGrid1.Left := 0;
    WebStringGrid1.Top := 130;
    WebStringGrid1.Width := 1138;
    WebStringGrid1.Height := 140;
    WebStringGrid1.Align := alClient;
    WebStringGrid1.TabOrder := 2;
    WebStringGrid1.FixedFont.Charset := DEFAULT_CHARSET;
    WebStringGrid1.FixedFont.Color := clWindowText;
    WebStringGrid1.FixedFont.Height := -12;
    WebStringGrid1.FixedFont.Name := 'Segoe UI';
    WebStringGrid1.FixedFont.Style := [];
    WebStringGrid1.RangeEdit.Max := 100.000000000000000000;
    WebStringGrid1.RangeEdit.Step := 1.000000000000000000;
    WebStringGrid1.HeightPercent := 100.000000000000000000;
    WebStringGrid1.WidthPercent := 100.000000000000000000;
    WebPanel19.SetParentComponent(WebPanel6);
    WebPanel19.Name := 'WebPanel19';
    WebPanel19.Left := 0;
    WebPanel19.Top := 270;
    WebPanel19.Width := 1138;
    WebPanel19.Height := 370;
    WebPanel19.Align := alClient;
    WebPanel19.ChildOrder := 1;
    WebPanel19.TabOrder := 1;
    WebLabel46.SetParentComponent(WebPanel19);
    WebLabel46.Name := 'WebLabel46';
    WebLabel46.Left := 784;
    WebLabel46.Top := 73;
    WebLabel46.Width := 54;
    WebLabel46.Height := 15;
    WebLabel46.Caption := 'Sort Order';
    WebLabel46.HeightPercent := 100.000000000000000000;
    WebLabel46.WidthPercent := 100.000000000000000000;
    WebLabel47.SetParentComponent(WebPanel19);
    WebLabel47.Name := 'WebLabel47';
    WebLabel47.Left := 917;
    WebLabel47.Top := 73;
    WebLabel47.Width := 60;
    WebLabel47.Height := 15;
    WebLabel47.Caption := 'Field Name';
    WebLabel47.HeightPercent := 100.000000000000000000;
    WebLabel47.WidthPercent := 100.000000000000000000;
    WebLabel48.SetParentComponent(WebPanel19);
    WebLabel48.Name := 'WebLabel48';
    WebLabel48.Left := 786;
    WebLabel48.Top := 139;
    WebLabel48.Width := 65;
    WebLabel48.Height := 15;
    WebLabel48.Caption := 'Column No:';
    WebLabel48.HeightPercent := 100.000000000000000000;
    WebLabel48.WidthPercent := 100.000000000000000000;
    WebLabel49.SetParentComponent(WebPanel19);
    WebLabel49.Name := 'WebLabel49';
    WebLabel49.Left := 913;
    WebLabel49.Top := 139;
    WebLabel49.Width := 49;
    WebLabel49.Height := 15;
    WebLabel49.Caption := 'DataType';
    WebLabel49.HeightPercent := 100.000000000000000000;
    WebLabel49.WidthPercent := 100.000000000000000000;
    WebLabel50.SetParentComponent(WebPanel19);
    WebLabel50.Name := 'WebLabel50';
    WebLabel50.Left := 784;
    WebLabel50.Top := 267;
    WebLabel50.Width := 76;
    WebLabel50.Height := 15;
    WebLabel50.Caption := 'DisplayFormat';
    WebLabel50.HeightPercent := 100.000000000000000000;
    WebLabel50.WidthPercent := 100.000000000000000000;
    WebLabel51.SetParentComponent(WebPanel19);
    WebLabel51.Name := 'WebLabel51';
    WebLabel51.Left := 786;
    WebLabel51.Top := 205;
    WebLabel51.Width := 58;
    WebLabel51.Height := 15;
    WebLabel51.Caption := 'Start Copy:';
    WebLabel51.HeightPercent := 100.000000000000000000;
    WebLabel51.WidthPercent := 100.000000000000000000;
    WebLabel52.SetParentComponent(WebPanel19);
    WebLabel52.Name := 'WebLabel52';
    WebLabel52.Left := 913;
    WebLabel52.Top := 203;
    WebLabel52.Width := 54;
    WebLabel52.Height := 15;
    WebLabel52.Caption := 'End Copy:';
    WebLabel52.HeightPercent := 100.000000000000000000;
    WebLabel52.WidthPercent := 100.000000000000000000;
    WebLabel53.SetParentComponent(WebPanel19);
    WebLabel53.Name := 'WebLabel53';
    WebLabel53.Left := 913;
    WebLabel53.Top := 269;
    WebLabel53.Width := 94;
    WebLabel53.Height := 15;
    WebLabel53.Caption := 'Character Ending:';
    WebLabel53.HeightPercent := 100.000000000000000000;
    WebLabel53.WidthPercent := 100.000000000000000000;
    edtSortOrder.SetParentComponent(WebPanel19);
    edtSortOrder.Name := 'edtSortOrder';
    edtSortOrder.Left := 786;
    edtSortOrder.Top := 94;
    edtSortOrder.Width := 121;
    edtSortOrder.Height := 22;
    edtSortOrder.ChildOrder := 9;
    edtSortOrder.Enabled := False;
    edtSortOrder.HeightPercent := 100.000000000000000000;
    edtSortOrder.Text := 'edtSortOrder';
    edtSortOrder.WidthPercent := 100.000000000000000000;
    edtSortOrder.DataField := 'SORTORDER';
    edtSortOrder.DataSource := dsInsertImportSetup;
    edtColumnNo.SetParentComponent(WebPanel19);
    edtColumnNo.Name := 'edtColumnNo';
    edtColumnNo.Left := 786;
    edtColumnNo.Top := 160;
    edtColumnNo.Width := 121;
    edtColumnNo.Height := 22;
    edtColumnNo.ChildOrder := 10;
    edtColumnNo.Enabled := False;
    edtColumnNo.HeightPercent := 100.000000000000000000;
    edtColumnNo.Text := 'edtColumnNo';
    edtColumnNo.WidthPercent := 100.000000000000000000;
    edtColumnNo.DataField := 'COLNO';
    edtColumnNo.DataSource := dsInsertImportSetup;
    edtDisplayFormat.SetParentComponent(WebPanel19);
    edtDisplayFormat.Name := 'edtDisplayFormat';
    edtDisplayFormat.Left := 788;
    edtDisplayFormat.Top := 288;
    edtDisplayFormat.Width := 121;
    edtDisplayFormat.Height := 22;
    edtDisplayFormat.ChildOrder := 12;
    edtDisplayFormat.Enabled := False;
    edtDisplayFormat.HeightPercent := 100.000000000000000000;
    edtDisplayFormat.Text := 'edtDisplayFormat';
    edtDisplayFormat.WidthPercent := 100.000000000000000000;
    edtDisplayFormat.DataField := 'FORMATDISPLAY';
    edtDisplayFormat.DataSource := dsInsertImportSetup;
    edtStartCopy.SetParentComponent(WebPanel19);
    edtStartCopy.Name := 'edtStartCopy';
    edtStartCopy.Left := 786;
    edtStartCopy.Top := 226;
    edtStartCopy.Width := 121;
    edtStartCopy.Height := 22;
    edtStartCopy.ChildOrder := 13;
    edtStartCopy.Enabled := False;
    edtStartCopy.HeightPercent := 100.000000000000000000;
    edtStartCopy.Text := 'edtStartCopy';
    edtStartCopy.WidthPercent := 100.000000000000000000;
    edtStartCopy.DataField := 'STARTCOPY';
    edtStartCopy.DataSource := dsInsertImportSetup;
    edtEndCopy.SetParentComponent(WebPanel19);
    edtEndCopy.Name := 'edtEndCopy';
    edtEndCopy.Left := 913;
    edtEndCopy.Top := 224;
    edtEndCopy.Width := 147;
    edtEndCopy.Height := 22;
    edtEndCopy.ChildOrder := 14;
    edtEndCopy.Enabled := False;
    edtEndCopy.HeightPercent := 100.000000000000000000;
    edtEndCopy.Text := 'edtEndCopy';
    edtEndCopy.WidthPercent := 100.000000000000000000;
    edtEndCopy.DataField := 'ENDCOPY';
    edtEndCopy.DataSource := dsInsertImportSetup;
    edtCharEnding.SetParentComponent(WebPanel19);
    edtCharEnding.Name := 'edtCharEnding';
    edtCharEnding.Left := 915;
    edtCharEnding.Top := 290;
    edtCharEnding.Width := 146;
    edtCharEnding.Height := 22;
    edtCharEnding.ChildOrder := 15;
    edtCharEnding.Enabled := False;
    edtCharEnding.HeightPercent := 100.000000000000000000;
    edtCharEnding.MaxLength := 1;
    edtCharEnding.Text := 'edtCharEnding';
    edtCharEnding.WidthPercent := 100.000000000000000000;
    edtCharEnding.DataField := 'CHAREND';
    edtCharEnding.DataSource := dsInsertImportSetup;
    edtFieldName.SetParentComponent(WebPanel19);
    edtFieldName.Name := 'edtFieldName';
    edtFieldName.Left := 913;
    edtFieldName.Top := 96;
    edtFieldName.Width := 148;
    edtFieldName.Height := 22;
    edtFieldName.ChildOrder := 16;
    edtFieldName.Enabled := False;
    edtFieldName.HeightPercent := 100.000000000000000000;
    edtFieldName.Text := 'edtFieldName';
    edtFieldName.WidthPercent := 100.000000000000000000;
    edtFieldName.DataField := 'FIELDNAME';
    edtFieldName.DataSource := dsInsertImportSetup;
    WebPanel20.SetParentComponent(WebPanel19);
    WebPanel20.Name := 'WebPanel20';
    WebPanel20.Left := 0;
    WebPanel20.Top := 0;
    WebPanel20.Width := 1138;
    WebPanel20.Height := 20;
    WebPanel20.Align := alTop;
    WebPanel20.ChildOrder := 17;
    WebPanel20.TabOrder := 7;
    TMSFNCDataGrid2.SetParentComponent(WebPanel19);
    TMSFNCDataGrid2.Name := 'TMSFNCDataGrid2';
    TMSFNCDataGrid2.Left := 0;
    TMSFNCDataGrid2.Top := 20;
    TMSFNCDataGrid2.Width := 737;
    TMSFNCDataGrid2.Height := 350;
    TMSFNCDataGrid2.Align := alLeft;
    TMSFNCDataGrid2.ParentDoubleBuffered := False;
    TMSFNCDataGrid2.DoubleBuffered := True;
    TMSFNCDataGrid2.Enabled := False;
    TMSFNCDataGrid2.TabOrder := 8;
    TMSFNCDataGrid2.ShowAcceleratorChar := False;
    TMSFNCDataGrid2.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    TMSFNCDataGrid2.Header.VisualGrouping.Layout.Font.Height := -12;
    TMSFNCDataGrid2.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.Header.VisualGrouping.Layout.Font.Style := [];
    TMSFNCDataGrid2.Adapter := dgdbaImportSetup;
    TMSFNCDataGrid2.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.FilterMatchLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.FilterMatchLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.BandLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.BandLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.BandLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.GroupLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.GroupLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.GroupLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.NormalLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.NormalLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.NormalLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.SummaryLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.SummaryLayout.Font.Style := [];
    TMSFNCDataGrid2.ColumnCount := 13;
    TMSFNCDataGrid2.Columns.Clear;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'AUTONO';
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'CONTRACTNO';
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SORTORDER';
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'COLNO';
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'FIELDNAME';
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'FIELDTYPE';
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'FORMATDISPLAY';
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'STARTCOPY';
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'ENDCOPY';
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'CHAREND';
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'IMPORTTYPE';
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'DEB_CODE';
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'IMPORTTYPEREC';
    end;
    TMSFNCDataGrid2.Designer := False;
    TMSFNCDataGrid2.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.FilterAppearance.Font.Color := clWindowText;
    TMSFNCDataGrid2.FilterAppearance.Font.Height := -12;
    TMSFNCDataGrid2.FilterAppearance.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.FilterAppearance.Font.Style := [];
    TMSFNCDataGrid2.Icons.ExpandIcon.LoadFromFile('ContractImportSetup.WebPanel19.TMSFNCDataGrid2.Icons.ExpandIcon.svg');
    TMSFNCDataGrid2.Icons.CollapseIcon.LoadFromFile('ContractImportSetup.WebPanel19.TMSFNCDataGrid2.Icons.CollapseIcon.svg');
    TMSFNCDataGrid2.Icons.FilterIcon.LoadFromFile('ContractImportSetup.WebPanel19.TMSFNCDataGrid2.Icons.FilterIcon.svg');
    TMSFNCDataGrid2.Icons.FilterActiveIcon.LoadFromFile('ContractImportSetup.WebPanel19.TMSFNCDataGrid2.Icons.FilterActiveIcon.svg');
    TMSFNCDataGrid2.Icons.FilterClearIcon.LoadFromFile('ContractImportSetup.WebPanel19.TMSFNCDataGrid2.Icons.FilterClearIcon.svg');
    TMSFNCDataGrid2.Icons.FilterTypeIcon.LoadFromFile('ContractImportSetup.WebPanel19.TMSFNCDataGrid2.Icons.FilterTypeIcon.svg');
    TMSFNCDataGrid2.Icons.SortAscendingIcon.LoadFromFile('ContractImportSetup.WebPanel19.TMSFNCDataGrid2.Icons.SortAscendingIcon.svg');
    TMSFNCDataGrid2.Icons.SortDescendingIcon.LoadFromFile('ContractImportSetup.WebPanel19.TMSFNCDataGrid2.Icons.SortDescendingIcon.svg');
    TMSFNCDataGrid2.Icons.CloseIcon.LoadFromFile('ContractImportSetup.WebPanel19.TMSFNCDataGrid2.Icons.CloseIcon.svg');
    TMSFNCDataGrid2.RowCount := 1;
    dgdbaImportSetup.SetParentComponent(TMSFNCDataGrid2);
    dgdbaImportSetup.Name := 'dgdbaImportSetup';
    dgdbaImportSetup.Left := 250;
    dgdbaImportSetup.Top := 48;
    dgdbaImportSetup.Width := 26;
    dgdbaImportSetup.Height := 26;
    dgdbaImportSetup.Visible := True;
    dgdbaImportSetup.Columns.Clear;
    with dgdbaImportSetup.Columns.Add do
    begin
      FieldName := 'AUTONO';
      Header := 'AUTONO';
      AutoCreated := False;
    end;
    with dgdbaImportSetup.Columns.Add do
    begin
      FieldName := 'CONTRACTNO';
      Header := 'CONTRACTNO';
      AutoCreated := False;
    end;
    with dgdbaImportSetup.Columns.Add do
    begin
      FieldName := 'SORTORDER';
      Header := 'SORTORDER';
      AutoCreated := False;
    end;
    with dgdbaImportSetup.Columns.Add do
    begin
      FieldName := 'COLNO';
      Header := 'COLNO';
      AutoCreated := False;
    end;
    with dgdbaImportSetup.Columns.Add do
    begin
      FieldName := 'FIELDNAME';
      Header := 'FIELDNAME';
      AutoCreated := False;
    end;
    with dgdbaImportSetup.Columns.Add do
    begin
      FieldName := 'FIELDTYPE';
      Header := 'FIELDTYPE';
      AutoCreated := False;
    end;
    with dgdbaImportSetup.Columns.Add do
    begin
      FieldName := 'FORMATDISPLAY';
      Header := 'FORMATDISPLAY';
      AutoCreated := False;
    end;
    with dgdbaImportSetup.Columns.Add do
    begin
      FieldName := 'STARTCOPY';
      Header := 'STARTCOPY';
      AutoCreated := False;
    end;
    with dgdbaImportSetup.Columns.Add do
    begin
      FieldName := 'ENDCOPY';
      Header := 'ENDCOPY';
      AutoCreated := False;
    end;
    with dgdbaImportSetup.Columns.Add do
    begin
      FieldName := 'CHAREND';
      Header := 'CHAREND';
      AutoCreated := False;
    end;
    with dgdbaImportSetup.Columns.Add do
    begin
      FieldName := 'IMPORTTYPE';
      Header := 'IMPORTTYPE';
      AutoCreated := False;
    end;
    with dgdbaImportSetup.Columns.Add do
    begin
      FieldName := 'DEB_CODE';
      Header := 'DEB_CODE';
      AutoCreated := False;
    end;
    with dgdbaImportSetup.Columns.Add do
    begin
      FieldName := 'IMPORTTYPEREC';
      Header := 'IMPORTTYPEREC';
      AutoCreated := False;
    end;
    dgdbaImportSetup.DataSource := dsImportSetup;
    btnFirst.SetParentComponent(WebPanel19);
    btnFirst.Name := 'btnFirst';
    btnFirst.Left := 786;
    btnFirst.Top := 26;
    btnFirst.Width := 24;
    btnFirst.Height := 24;
    btnFirst.Caption := '<<';
    btnFirst.Color := clNone;
    btnFirst.HeightPercent := 100.000000000000000000;
    btnFirst.TabOrder := 9;
    btnFirst.WidthPercent := 100.000000000000000000;
    btnPrior.SetParentComponent(WebPanel19);
    btnPrior.Name := 'btnPrior';
    btnPrior.Left := 826;
    btnPrior.Top := 26;
    btnPrior.Width := 24;
    btnPrior.Height := 24;
    btnPrior.Caption := ' <';
    btnPrior.Color := clNone;
    btnPrior.HeightPercent := 100.000000000000000000;
    btnPrior.TabOrder := 10;
    btnPrior.WidthPercent := 100.000000000000000000;
    btnNext.SetParentComponent(WebPanel19);
    btnNext.Name := 'btnNext';
    btnNext.Left := 866;
    btnNext.Top := 26;
    btnNext.Width := 24;
    btnNext.Height := 24;
    btnNext.Caption := '>';
    btnNext.Color := clNone;
    btnNext.HeightPercent := 100.000000000000000000;
    btnNext.TabOrder := 11;
    btnNext.WidthPercent := 100.000000000000000000;
    btnLast.SetParentComponent(WebPanel19);
    btnLast.Name := 'btnLast';
    btnLast.Left := 906;
    btnLast.Top := 26;
    btnLast.Width := 24;
    btnLast.Height := 24;
    btnLast.Caption := '>>';
    btnLast.Color := clNone;
    btnLast.HeightPercent := 100.000000000000000000;
    btnLast.TabOrder := 12;
    btnLast.WidthPercent := 100.000000000000000000;
    btnInsert.SetParentComponent(WebPanel19);
    btnInsert.Name := 'btnInsert';
    btnInsert.Left := 946;
    btnInsert.Top := 26;
    btnInsert.Width := 24;
    btnInsert.Height := 24;
    btnInsert.Caption := '+';
    btnInsert.Color := clNone;
    btnInsert.HeightPercent := 100.000000000000000000;
    btnInsert.TabOrder := 13;
    btnInsert.WidthPercent := 100.000000000000000000;
    SetEvent(btnInsert, Self, 'OnClick', 'btnInsertClick');
    btnSearchFieldName.SetParentComponent(WebPanel19);
    btnSearchFieldName.Name := 'btnSearchFieldName';
    btnSearchFieldName.Left := 1067;
    btnSearchFieldName.Top := 96;
    btnSearchFieldName.Width := 25;
    btnSearchFieldName.Height := 25;
    btnSearchFieldName.Caption := '...';
    btnSearchFieldName.ChildOrder := 24;
    btnSearchFieldName.Enabled := False;
    btnSearchFieldName.HeightPercent := 100.000000000000000000;
    btnSearchFieldName.WidthPercent := 100.000000000000000000;
    btnSaveSetup.SetParentComponent(WebPanel19);
    btnSaveSetup.Name := 'btnSaveSetup';
    btnSaveSetup.Left := 989;
    btnSaveSetup.Top := 26;
    btnSaveSetup.Width := 62;
    btnSaveSetup.Height := 24;
    btnSaveSetup.Caption := 'Save';
    btnSaveSetup.Color := clNone;
    btnSaveSetup.Enabled := False;
    btnSaveSetup.HeightPercent := 100.000000000000000000;
    btnSaveSetup.TabOrder := 15;
    btnSaveSetup.WidthPercent := 100.000000000000000000;
    SetEvent(btnSaveSetup, Self, 'OnClick', 'btnSaveSetupClick');
    btnCancelSetup.SetParentComponent(WebPanel19);
    btnCancelSetup.Name := 'btnCancelSetup';
    btnCancelSetup.Left := 1057;
    btnCancelSetup.Top := 26;
    btnCancelSetup.Width := 65;
    btnCancelSetup.Height := 24;
    btnCancelSetup.Caption := ' Cancel';
    btnCancelSetup.Color := clNone;
    btnCancelSetup.Enabled := False;
    btnCancelSetup.HeightPercent := 100.000000000000000000;
    btnCancelSetup.TabOrder := 16;
    btnCancelSetup.WidthPercent := 100.000000000000000000;
    SetEvent(btnCancelSetup, Self, 'OnClick', 'btnCancelSetupClick');
    cbbDataType.SetParentComponent(WebPanel19);
    cbbDataType.Name := 'cbbDataType';
    cbbDataType.Left := 913;
    cbbDataType.Top := 160;
    cbbDataType.Width := 145;
    cbbDataType.Height := 23;
    cbbDataType.Enabled := False;
    cbbDataType.HeightPercent := 100.000000000000000000;
    cbbDataType.Text := 'cbbDataType';
    cbbDataType.WidthPercent := 100.000000000000000000;
    cbbDataType.ItemIndex := -1;
    cbbDataType.Items.BeginUpdate;
    try
      cbbDataType.Items.Clear;
      cbbDataType.Items.Add('ftDate');
      cbbDataType.Items.Add('ftDateTime');
      cbbDataType.Items.Add('ftFloat');
      cbbDataType.Items.Add('ftInteger');
      cbbDataType.Items.Add('ftString');
      cbbDataType.Items.Add('ftTime');
    finally
      cbbDataType.Items.EndUpdate;
    end;
    cbbDataType.DataField := 'FIELDTYPE';
    cbbDataType.DataSource := dsInsertImportSetup;
    WebSpeedButton1.SetParentComponent(WebPanel19);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 1021;
    WebSpeedButton1.Top := 56;
    WebSpeedButton1.Width := 62;
    WebSpeedButton1.Height := 24;
    WebSpeedButton1.Caption := 'Delete';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 18;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    wcImportSetup.SetParentComponent(Self);
    wcImportSetup.Name := 'wcImportSetup';
    wcImportSetup.Connection := dmData.dbConnect;
    wcImportSetup.Left := 40;
    wcImportSetup.Top := 338;
    wdsImportSetup.SetParentComponent(Self);
    wdsImportSetup.Name := 'wdsImportSetup';
    wdsImportSetup.Connection := dmData.dbConnect;
    wdsImportSetup.Left := 112;
    wdsImportSetup.Top := 338;
    wdsImportSetupAUTONO.SetParentComponent(wdsImportSetup);
    wdsImportSetupAUTONO.Name := 'wdsImportSetupAUTONO';
    wdsImportSetupAUTONO.FieldName := 'AUTONO';
    wdsImportSetupCONTRACTNO.SetParentComponent(wdsImportSetup);
    wdsImportSetupCONTRACTNO.Name := 'wdsImportSetupCONTRACTNO';
    wdsImportSetupCONTRACTNO.FieldName := 'CONTRACTNO';
    wdsImportSetupSORTORDER.SetParentComponent(wdsImportSetup);
    wdsImportSetupSORTORDER.Name := 'wdsImportSetupSORTORDER';
    wdsImportSetupSORTORDER.FieldName := 'SORTORDER';
    wdsImportSetupCOLNO.SetParentComponent(wdsImportSetup);
    wdsImportSetupCOLNO.Name := 'wdsImportSetupCOLNO';
    wdsImportSetupCOLNO.FieldName := 'COLNO';
    wdsImportSetupFIELDNAME.SetParentComponent(wdsImportSetup);
    wdsImportSetupFIELDNAME.Name := 'wdsImportSetupFIELDNAME';
    wdsImportSetupFIELDNAME.FieldName := 'FIELDNAME';
    wdsImportSetupFIELDTYPE.SetParentComponent(wdsImportSetup);
    wdsImportSetupFIELDTYPE.Name := 'wdsImportSetupFIELDTYPE';
    wdsImportSetupFIELDTYPE.FieldName := 'FIELDTYPE';
    wdsImportSetupFORMATDISPLAY.SetParentComponent(wdsImportSetup);
    wdsImportSetupFORMATDISPLAY.Name := 'wdsImportSetupFORMATDISPLAY';
    wdsImportSetupFORMATDISPLAY.FieldName := 'FORMATDISPLAY';
    wdsImportSetupSTARTCOPY.SetParentComponent(wdsImportSetup);
    wdsImportSetupSTARTCOPY.Name := 'wdsImportSetupSTARTCOPY';
    wdsImportSetupSTARTCOPY.FieldName := 'STARTCOPY';
    wdsImportSetupENDCOPY.SetParentComponent(wdsImportSetup);
    wdsImportSetupENDCOPY.Name := 'wdsImportSetupENDCOPY';
    wdsImportSetupENDCOPY.FieldName := 'ENDCOPY';
    wdsImportSetupCHAREND.SetParentComponent(wdsImportSetup);
    wdsImportSetupCHAREND.Name := 'wdsImportSetupCHAREND';
    wdsImportSetupCHAREND.FieldName := 'CHAREND';
    wdsImportSetupIMPORTTYPE.SetParentComponent(wdsImportSetup);
    wdsImportSetupIMPORTTYPE.Name := 'wdsImportSetupIMPORTTYPE';
    wdsImportSetupIMPORTTYPE.FieldName := 'IMPORTTYPE';
    wdsImportSetupDEB_CODE.SetParentComponent(wdsImportSetup);
    wdsImportSetupDEB_CODE.Name := 'wdsImportSetupDEB_CODE';
    wdsImportSetupDEB_CODE.FieldName := 'DEB_CODE';
    wdsImportSetupIMPORTTYPEREC.SetParentComponent(wdsImportSetup);
    wdsImportSetupIMPORTTYPEREC.Name := 'wdsImportSetupIMPORTTYPEREC';
    wdsImportSetupIMPORTTYPEREC.FieldName := 'IMPORTTYPEREC';
    dsImportSetup.SetParentComponent(Self);
    dsImportSetup.Name := 'dsImportSetup';
    dsImportSetup.DataSet := wdsImportSetup;
    dsImportSetup.Left := 184;
    dsImportSetup.Top := 338;
    wdsDisplay.SetParentComponent(Self);
    wdsDisplay.Name := 'wdsDisplay';
    wdsDisplay.Connection := dmData.dbConnect;
    wdsDisplay.Left := 128;
    wdsDisplay.Top := 186;
    wdsDisplayDEB_NAME.SetParentComponent(wdsDisplay);
    wdsDisplayDEB_NAME.Name := 'wdsDisplayDEB_NAME';
    wdsDisplayDEB_NAME.FieldName := 'DEB_NAME';
    wdsDisplayCONTRACTNAME.SetParentComponent(wdsDisplay);
    wdsDisplayCONTRACTNAME.Name := 'wdsDisplayCONTRACTNAME';
    wdsDisplayCONTRACTNAME.FieldName := 'CONTRACTNAME';
    dsDisplay.SetParentComponent(Self);
    dsDisplay.Name := 'dsDisplay';
    dsDisplay.DataSet := wdsDisplay;
    dsDisplay.Left := 200;
    dsDisplay.Top := 186;
    wcDisplay.SetParentComponent(Self);
    wcDisplay.Name := 'wcDisplay';
    wcDisplay.Connection := dmData.dbConnect;
    wcDisplay.Left := 56;
    wcDisplay.Top := 186;
    WebXLSX1.SetParentComponent(Self);
    WebXLSX1.Name := 'WebXLSX1';
    WebXLSX1.Grid := WebStringGrid1;
    WebXLSX1.Left := 160;
    WebXLSX1.Top := 88;
    dsInsertImportSetup.SetParentComponent(Self);
    dsInsertImportSetup.Name := 'dsInsertImportSetup';
    dsInsertImportSetup.DataSet := wdsInsertImportSetup;
    dsInsertImportSetup.Left := 664;
    dsInsertImportSetup.Top := 362;
    wdsContract.SetParentComponent(Self);
    wdsContract.Name := 'wdsContract';
    wdsContract.Connection := dmData.dbConnect;
    wdsContract.Left := 176;
    wdsContract.Top := 20;
    IntegerField32.SetParentComponent(wdsContract);
    IntegerField32.Name := 'IntegerField32';
    IntegerField32.FieldName := 'CONTRACTNO';
    StringField94.SetParentComponent(wdsContract);
    StringField94.Name := 'StringField94';
    StringField94.FieldName := 'CONTRACTNAME';
    StringField95.SetParentComponent(wdsContract);
    StringField95.Name := 'StringField95';
    StringField95.FieldName := 'DEBCODE';
    IntegerField33.SetParentComponent(wdsContract);
    IntegerField33.Name := 'IntegerField33';
    IntegerField33.FieldName := 'COMMODITIESNO';
    IntegerField34.SetParentComponent(wdsContract);
    IntegerField34.Name := 'IntegerField34';
    IntegerField34.FieldName := 'LOADCOUNTRYNO';
    IntegerField35.SetParentComponent(wdsContract);
    IntegerField35.Name := 'IntegerField35';
    IntegerField35.FieldName := 'LOADPROVINCENO';
    IntegerField36.SetParentComponent(wdsContract);
    IntegerField36.Name := 'IntegerField36';
    IntegerField36.FieldName := 'LOADCITYNO';
    IntegerField37.SetParentComponent(wdsContract);
    IntegerField37.Name := 'IntegerField37';
    IntegerField37.FieldName := 'LOADINGNO';
    IntegerField38.SetParentComponent(wdsContract);
    IntegerField38.Name := 'IntegerField38';
    IntegerField38.FieldName := 'OFFLOADCOUNTRYNO';
    IntegerField39.SetParentComponent(wdsContract);
    IntegerField39.Name := 'IntegerField39';
    IntegerField39.FieldName := 'OFFLOADPROVINCENO';
    IntegerField40.SetParentComponent(wdsContract);
    IntegerField40.Name := 'IntegerField40';
    IntegerField40.FieldName := 'OFFLOADCITYNO';
    IntegerField41.SetParentComponent(wdsContract);
    IntegerField41.Name := 'IntegerField41';
    IntegerField41.FieldName := 'OFFLOADINGNO';
    StringField96.SetParentComponent(wdsContract);
    StringField96.Name := 'StringField96';
    StringField96.FieldName := 'INVLOADING';
    StringField97.SetParentComponent(wdsContract);
    StringField97.Name := 'StringField97';
    StringField97.FieldName := 'INVOFFLOADING';
    FloatField17.SetParentComponent(wdsContract);
    FloatField17.Name := 'FloatField17';
    FloatField17.FieldName := 'TOTALTONS';
    FloatField18.SetParentComponent(wdsContract);
    FloatField18.Name := 'FloatField18';
    FloatField18.FieldName := 'TOTALTONSORDER';
    FloatField19.SetParentComponent(wdsContract);
    FloatField19.Name := 'FloatField19';
    FloatField19.FieldName := 'TOTALTONSLOADED';
    FloatField20.SetParentComponent(wdsContract);
    FloatField20.Name := 'FloatField20';
    FloatField20.FieldName := 'TOTALTONSOFFLOADED';
    FloatField21.SetParentComponent(wdsContract);
    FloatField21.Name := 'FloatField21';
    FloatField21.FieldName := 'TOTALTONSINVOICED';
    StringField98.SetParentComponent(wdsContract);
    StringField98.Name := 'StringField98';
    StringField98.FieldName := 'COMPLETED';
    StringField99.SetParentComponent(wdsContract);
    StringField99.Name := 'StringField99';
    StringField99.FieldName := 'CONTROLLER';
    StringField99.Size := 0;
    FloatField22.SetParentComponent(wdsContract);
    FloatField22.Name := 'FloatField22';
    FloatField22.FieldName := 'AVGTONS';
    IntegerField42.SetParentComponent(wdsContract);
    IntegerField42.Name := 'IntegerField42';
    IntegerField42.FieldName := 'TOTALLOADS';
    IntegerField43.SetParentComponent(wdsContract);
    IntegerField43.Name := 'IntegerField43';
    IntegerField43.FieldName := 'LOADSORDER';
    IntegerField44.SetParentComponent(wdsContract);
    IntegerField44.Name := 'IntegerField44';
    IntegerField44.FieldName := 'LOADSLOADED';
    IntegerField45.SetParentComponent(wdsContract);
    IntegerField45.Name := 'IntegerField45';
    IntegerField45.FieldName := 'LOADSOFFLOADED';
    IntegerField46.SetParentComponent(wdsContract);
    IntegerField46.Name := 'IntegerField46';
    IntegerField46.FieldName := 'LOADSINVOICED';
    IntegerField47.SetParentComponent(wdsContract);
    IntegerField47.Name := 'IntegerField47';
    IntegerField47.FieldName := 'PAYMENTTERMS';
    IntegerField48.SetParentComponent(wdsContract);
    IntegerField48.Name := 'IntegerField48';
    IntegerField48.FieldName := 'PAYMENTTYPE';
    StringField100.SetParentComponent(wdsContract);
    StringField100.Name := 'StringField100';
    StringField100.FieldName := 'ADDHOC';
    StringField101.SetParentComponent(wdsContract);
    StringField101.Name := 'StringField101';
    StringField101.FieldName := 'DEDICATED';
    StringField102.SetParentComponent(wdsContract);
    StringField102.Name := 'StringField102';
    StringField102.FieldName := 'ORDERNO';
    StringField103.SetParentComponent(wdsContract);
    StringField103.Name := 'StringField103';
    StringField103.FieldName := 'INVVAT';
    StringField104.SetParentComponent(wdsContract);
    StringField104.Name := 'StringField104';
    StringField104.FieldName := 'MULTILOADINV';
    StringField105.SetParentComponent(wdsContract);
    StringField105.Name := 'StringField105';
    StringField105.FieldName := 'SENDED';
    StringField106.SetParentComponent(wdsContract);
    StringField106.Name := 'StringField106';
    StringField106.FieldName := 'PRELISTING';
    StringField107.SetParentComponent(wdsContract);
    StringField107.Name := 'StringField107';
    StringField107.FieldName := 'POSTLISTING';
    StringField108.SetParentComponent(wdsContract);
    StringField108.Name := 'StringField108';
    StringField108.FieldName := 'INVOICETYPE';
    FloatField23.SetParentComponent(wdsContract);
    FloatField23.Name := 'FloatField23';
    FloatField23.FieldName := 'DISTANCE';
    SmallintField4.SetParentComponent(wdsContract);
    SmallintField4.Name := 'SmallintField4';
    SmallintField4.FieldName := 'DRIVERRATIO';
    SmallintField5.SetParentComponent(wdsContract);
    SmallintField5.Name := 'SmallintField5';
    SmallintField5.FieldName := 'CUTOFF1';
    IntegerField49.SetParentComponent(wdsContract);
    IntegerField49.Name := 'IntegerField49';
    IntegerField49.FieldName := 'CUTOFFPERIOD1';
    SmallintField6.SetParentComponent(wdsContract);
    SmallintField6.Name := 'SmallintField6';
    SmallintField6.FieldName := 'CUTOFF2';
    IntegerField50.SetParentComponent(wdsContract);
    IntegerField50.Name := 'IntegerField50';
    IntegerField50.FieldName := 'CUTOFFPERIOD2';
    StringField109.SetParentComponent(wdsContract);
    StringField109.Name := 'StringField109';
    StringField109.FieldName := 'SAGEINVENTORY';
    StringField110.SetParentComponent(wdsContract);
    StringField110.Name := 'StringField110';
    StringField110.FieldName := 'SAGEGL';
    StringField111.SetParentComponent(wdsContract);
    StringField111.Name := 'StringField111';
    StringField111.FieldName := 'SAGECODE';
    StringField112.SetParentComponent(wdsContract);
    StringField112.Name := 'StringField112';
    StringField112.FieldName := 'SAGEEXPCODE';
    StringField113.SetParentComponent(wdsContract);
    StringField113.Name := 'StringField113';
    StringField113.FieldName := 'STRATERATE';
    StringField114.SetParentComponent(wdsContract);
    StringField114.Name := 'StringField114';
    StringField114.FieldName := 'CHGOFFLOAD';
    StringField115.SetParentComponent(wdsContract);
    StringField115.Name := 'StringField115';
    StringField115.FieldName := 'CHGPRICE';
    StringField116.SetParentComponent(wdsContract);
    StringField116.Name := 'StringField116';
    StringField116.FieldName := 'CAPTURETONS';
    StringField117.SetParentComponent(wdsContract);
    StringField117.Name := 'StringField117';
    StringField117.FieldName := 'INVOICETONS';
    StringField118.SetParentComponent(wdsContract);
    StringField118.Name := 'StringField118';
    StringField118.FieldName := 'CHGSUBPRICE';
    IntegerField51.SetParentComponent(wdsContract);
    IntegerField51.Name := 'IntegerField51';
    IntegerField51.FieldName := 'MAXLOADORDERS';
    StringField119.SetParentComponent(wdsContract);
    StringField119.Name := 'StringField119';
    StringField119.FieldName := 'ADDDESCRIPTION';
    IntegerField52.SetParentComponent(wdsContract);
    IntegerField52.Name := 'IntegerField52';
    IntegerField52.FieldName := 'VARIANCETYPE';
    FloatField24.SetParentComponent(wdsContract);
    FloatField24.Name := 'FloatField24';
    FloatField24.FieldName := 'VARIANCEVALUE';
    StringField120.SetParentComponent(wdsContract);
    StringField120.Name := 'StringField120';
    StringField120.FieldName := 'PRINTLC';
    StringField121.SetParentComponent(wdsContract);
    StringField121.Name := 'StringField121';
    StringField121.FieldName := 'PRINTDN';
    StringField122.SetParentComponent(wdsContract);
    StringField122.Name := 'StringField122';
    StringField122.FieldName := 'PRINTTS';
    StringField123.SetParentComponent(wdsContract);
    StringField123.Name := 'StringField123';
    StringField123.FieldName := 'DNTYPE';
    StringField124.SetParentComponent(wdsContract);
    StringField124.Name := 'StringField124';
    StringField124.FieldName := 'TSTYPE';
    StringField125.SetParentComponent(wdsContract);
    StringField125.Name := 'StringField125';
    StringField125.FieldName := 'SHORTDESC';
    StringField126.SetParentComponent(wdsContract);
    StringField126.Name := 'StringField126';
    StringField126.FieldName := 'OLDLOADSCREEN';
    StringField127.SetParentComponent(wdsContract);
    StringField127.Name := 'StringField127';
    StringField127.FieldName := 'SHOWBOOKINGS';
    StringField128.SetParentComponent(wdsContract);
    StringField128.Name := 'StringField128';
    StringField128.FieldName := 'SHOWADDITIONAL';
    IntegerField53.SetParentComponent(wdsContract);
    IntegerField53.Name := 'IntegerField53';
    IntegerField53.FieldName := 'PRICETYPE';
    StringField129.SetParentComponent(wdsContract);
    StringField129.Name := 'StringField129';
    StringField129.FieldName := 'USEDOCKETINVNO';
    StringField130.SetParentComponent(wdsContract);
    StringField130.Name := 'StringField130';
    StringField130.FieldName := 'SAGECODE2';
    StringField131.SetParentComponent(wdsContract);
    StringField131.Name := 'StringField131';
    StringField131.FieldName := 'SAGEEXPCODE2';
    StringField132.SetParentComponent(wdsContract);
    StringField132.Name := 'StringField132';
    StringField132.FieldName := 'SAGEINVENTORY2';
    StringField133.SetParentComponent(wdsContract);
    StringField133.Name := 'StringField133';
    StringField133.FieldName := 'SAGEGL2';
    StringField134.SetParentComponent(wdsContract);
    StringField134.Name := 'StringField134';
    StringField134.FieldName := 'HAULAGETYPE';
    StringField135.SetParentComponent(wdsContract);
    StringField135.Name := 'StringField135';
    StringField135.FieldName := 'LINKZEROML';
    StringField136.SetParentComponent(wdsContract);
    StringField136.Name := 'StringField136';
    StringField136.FieldName := 'ATTACHEDEMAIL';
    IntegerField54.SetParentComponent(wdsContract);
    IntegerField54.Name := 'IntegerField54';
    IntegerField54.FieldName := 'CLIENTLINKCONTRACT';
    StringField137.SetParentComponent(wdsContract);
    StringField137.Name := 'StringField137';
    StringField137.FieldName := 'QUOTEREFNO';
    StringField138.SetParentComponent(wdsContract);
    StringField138.Name := 'StringField138';
    StringField138.FieldName := 'SORTLOADDATE';
    StringField139.SetParentComponent(wdsContract);
    StringField139.Name := 'StringField139';
    StringField139.FieldName := 'SORTOFFDATE';
    StringField140.SetParentComponent(wdsContract);
    StringField140.Name := 'StringField140';
    StringField140.FieldName := 'SORTLOADWAY';
    StringField141.SetParentComponent(wdsContract);
    StringField141.Name := 'StringField141';
    StringField141.FieldName := 'SORTOFFWAY';
    StringField142.SetParentComponent(wdsContract);
    StringField142.Name := 'StringField142';
    StringField142.FieldName := 'SORTDOCKET';
    StringField143.SetParentComponent(wdsContract);
    StringField143.Name := 'StringField143';
    StringField143.FieldName := 'SINVVAT';
    FloatField25.SetParentComponent(wdsContract);
    FloatField25.Name := 'FloatField25';
    FloatField25.FieldName := 'LOADINSTRUCTQTY';
    StringField144.SetParentComponent(wdsContract);
    StringField144.Name := 'StringField144';
    StringField144.FieldName := 'CHGLOAD';
    StringField144.Size := 0;
    StringField145.SetParentComponent(wdsContract);
    StringField145.Name := 'StringField145';
    StringField145.FieldName := 'soanalysiscat1';
    StringField146.SetParentComponent(wdsContract);
    StringField146.Name := 'StringField146';
    StringField146.FieldName := 'soanalysiscat2';
    StringField147.SetParentComponent(wdsContract);
    StringField147.Name := 'StringField147';
    StringField147.FieldName := 'soanalysiscat3';
    StringField148.SetParentComponent(wdsContract);
    StringField148.Name := 'StringField148';
    StringField148.FieldName := 'maxdrivetime';
    TimeField2.SetParentComponent(wdsContract);
    TimeField2.Name := 'TimeField2';
    TimeField2.FieldName := 'maxtrafeltime';
    IntegerField55.SetParentComponent(wdsContract);
    IntegerField55.Name := 'IntegerField55';
    IntegerField55.FieldName := 'firstwarning';
    IntegerField56.SetParentComponent(wdsContract);
    IntegerField56.Name := 'IntegerField56';
    IntegerField56.FieldName := 'secondwarning';
    IntegerField57.SetParentComponent(wdsContract);
    IntegerField57.Name := 'IntegerField57';
    IntegerField57.FieldName := 'slots';
    DateField4.SetParentComponent(wdsContract);
    DateField4.Name := 'DateField4';
    DateField4.FieldName := 'STARTDATE';
    DateField5.SetParentComponent(wdsContract);
    DateField5.Name := 'DateField5';
    DateField5.FieldName := 'COMPDATE';
    DateField6.SetParentComponent(wdsContract);
    DateField6.Name := 'DateField6';
    DateField6.FieldName := 'SENDEDDATE';
    StringField149.SetParentComponent(wdsContract);
    StringField149.Name := 'StringField149';
    StringField149.FieldName := 'DEB_CODE';
    StringField150.SetParentComponent(wdsContract);
    StringField150.Name := 'StringField150';
    StringField150.FieldName := 'DEB_NAME';
    StringField151.SetParentComponent(wdsContract);
    StringField151.Name := 'StringField151';
    StringField151.FieldName := 'SUSPENDED';
    FloatField26.SetParentComponent(wdsContract);
    FloatField26.Name := 'FloatField26';
    FloatField26.FieldName := 'CREDITLIMIT';
    FloatField27.SetParentComponent(wdsContract);
    FloatField27.Name := 'FloatField27';
    FloatField27.FieldName := 'ORDERBALANCE';
    FloatField28.SetParentComponent(wdsContract);
    FloatField28.Name := 'FloatField28';
    FloatField28.FieldName := 'INVOICEBALANCE';
    FloatField29.SetParentComponent(wdsContract);
    FloatField29.Name := 'FloatField29';
    FloatField29.FieldName := 'AVAILIBLECL';
    StringField152.SetParentComponent(wdsContract);
    StringField152.Name := 'StringField152';
    StringField152.FieldName := 'CLIENTMULTILOADINV';
    StringField153.SetParentComponent(wdsContract);
    StringField153.Name := 'StringField153';
    StringField153.FieldName := 'MULTILOADDESC';
    StringField154.SetParentComponent(wdsContract);
    StringField154.Name := 'StringField154';
    StringField154.FieldName := 'CLIENTINVOICETYPE';
    StringField155.SetParentComponent(wdsContract);
    StringField155.Name := 'StringField155';
    StringField155.FieldName := 'MULTICONTRACT';
    StringField156.SetParentComponent(wdsContract);
    StringField156.Name := 'StringField156';
    StringField156.FieldName := 'CLIENTLINKED';
    StringField157.SetParentComponent(wdsContract);
    StringField157.Name := 'StringField157';
    StringField157.FieldName := 'CLIENTEMAIL';
    StringField158.SetParentComponent(wdsContract);
    StringField158.Name := 'StringField158';
    StringField158.FieldName := 'LINKEDCONFIG';
    StringField159.SetParentComponent(wdsContract);
    StringField159.Name := 'StringField159';
    StringField159.FieldName := 'ACCOUNTNUMBER';
    FloatField30.SetParentComponent(wdsContract);
    FloatField30.Name := 'FloatField30';
    FloatField30.FieldName := 'MAINBALANCE';
    StringField160.SetParentComponent(wdsContract);
    StringField160.Name := 'StringField160';
    StringField160.FieldName := 'MAINTENANCELINKACCOUNT';
    StringField161.SetParentComponent(wdsContract);
    StringField161.Name := 'StringField161';
    StringField161.FieldName := 'EXPORTLIST';
    StringField162.SetParentComponent(wdsContract);
    StringField162.Name := 'StringField162';
    StringField162.FieldName := 'EXPORTLOADS';
    StringField163.SetParentComponent(wdsContract);
    StringField163.Name := 'StringField163';
    StringField163.FieldName := 'RENAMEFIELD';
    StringField164.SetParentComponent(wdsContract);
    StringField164.Name := 'StringField164';
    StringField164.FieldName := 'EXPORTPATH';
    FloatField31.SetParentComponent(wdsContract);
    FloatField31.Name := 'FloatField31';
    FloatField31.FieldName := 'PREVCL';
    StringField165.SetParentComponent(wdsContract);
    StringField165.Name := 'StringField165';
    StringField165.FieldName := 'SECUREBOOK';
    StringField166.SetParentComponent(wdsContract);
    StringField166.Name := 'StringField166';
    StringField166.FieldName := 'QUOTESYSTEM';
    StringField167.SetParentComponent(wdsContract);
    StringField167.Name := 'StringField167';
    StringField167.FieldName := 'QUOTETYPE';
    StringField168.SetParentComponent(wdsContract);
    StringField168.Name := 'StringField168';
    StringField168.FieldName := 'EMAILLOADDOCS';
    StringField169.SetParentComponent(wdsContract);
    StringField169.Name := 'StringField169';
    StringField169.FieldName := 'STATEMENTTYPE';
    StringField170.SetParentComponent(wdsContract);
    StringField170.Name := 'StringField170';
    StringField170.FieldName := 'SHOWRECLOADS';
    StringField171.SetParentComponent(wdsContract);
    StringField171.Name := 'StringField171';
    StringField171.FieldName := 'LINKEDINVTYPE';
    IntegerField58.SetParentComponent(wdsContract);
    IntegerField58.Name := 'IntegerField58';
    IntegerField58.FieldName := 'DEFINVCOMPNO';
    StringField172.SetParentComponent(wdsContract);
    StringField172.Name := 'StringField172';
    StringField172.FieldName := 'invoicetypenoncon';
    StringField172.Size := 0;
    StringField173.SetParentComponent(wdsContract);
    StringField173.Name := 'StringField173';
    StringField173.FieldName := 'singlenoncon';
    StringField174.SetParentComponent(wdsContract);
    StringField174.Name := 'StringField174';
    StringField174.FieldName := 'LINKSERIAL';
    StringField175.SetParentComponent(wdsContract);
    StringField175.Name := 'StringField175';
    StringField175.FieldName := 'LINKAPI';
    StringField176.SetParentComponent(wdsContract);
    StringField176.Name := 'StringField176';
    StringField176.FieldName := 'serverip';
    IntegerField59.SetParentComponent(wdsContract);
    IntegerField59.Name := 'IntegerField59';
    IntegerField59.FieldName := 'serverport';
    StringField177.SetParentComponent(wdsContract);
    StringField177.Name := 'StringField177';
    StringField177.FieldName := 'serveruser';
    StringField178.SetParentComponent(wdsContract);
    StringField178.Name := 'StringField178';
    StringField178.FieldName := 'serverpassword';
    StringField179.SetParentComponent(wdsContract);
    StringField179.Name := 'StringField179';
    StringField179.FieldName := 'serveraccount';
    StringField180.SetParentComponent(wdsContract);
    StringField180.Name := 'StringField180';
    StringField180.FieldName := 'altserverip';
    IntegerField60.SetParentComponent(wdsContract);
    IntegerField60.Name := 'IntegerField60';
    IntegerField60.FieldName := 'altserverport';
    StringField181.SetParentComponent(wdsContract);
    StringField181.Name := 'StringField181';
    StringField181.FieldName := 'altserveruser';
    StringField182.SetParentComponent(wdsContract);
    StringField182.Name := 'StringField182';
    StringField182.FieldName := 'altserverpassword';
    StringField183.SetParentComponent(wdsContract);
    StringField183.Name := 'StringField183';
    StringField183.FieldName := 'serversystem';
    IntegerField61.SetParentComponent(wdsContract);
    IntegerField61.Name := 'IntegerField61';
    IntegerField61.FieldName := 'No';
    StringField184.SetParentComponent(wdsContract);
    StringField184.Name := 'StringField184';
    StringField184.FieldName := 'NAME';
    StringField185.SetParentComponent(wdsContract);
    StringField185.Name := 'StringField185';
    StringField185.FieldName := 'ITEMCODE';
    IntegerField62.SetParentComponent(wdsContract);
    IntegerField62.Name := 'IntegerField62';
    IntegerField62.FieldName := 'STORE';
    StringField186.SetParentComponent(wdsContract);
    StringField186.Name := 'StringField186';
    StringField186.FieldName := 'UNITNUMBER';
    FloatField32.SetParentComponent(wdsContract);
    FloatField32.Name := 'FloatField32';
    FloatField32.FieldName := 'DENSITY';
    StringField187.SetParentComponent(wdsContract);
    StringField187.Name := 'StringField187';
    StringField187.FieldName := 'LoadCountryName';
    StringField188.SetParentComponent(wdsContract);
    StringField188.Name := 'StringField188';
    StringField188.FieldName := 'LoadProvinceName';
    StringField189.SetParentComponent(wdsContract);
    StringField189.Name := 'StringField189';
    StringField189.FieldName := 'LoadCityName';
    StringField190.SetParentComponent(wdsContract);
    StringField190.Name := 'StringField190';
    StringField190.FieldName := 'LoadInfoName';
    StringField191.SetParentComponent(wdsContract);
    StringField191.Name := 'StringField191';
    StringField191.FieldName := 'OffLoadCountryName';
    StringField192.SetParentComponent(wdsContract);
    StringField192.Name := 'StringField192';
    StringField192.FieldName := 'OffLoadProvinceName';
    StringField193.SetParentComponent(wdsContract);
    StringField193.Name := 'StringField193';
    StringField193.FieldName := 'OffLoadCityName';
    StringField194.SetParentComponent(wdsContract);
    StringField194.Name := 'StringField194';
    StringField194.FieldName := 'OffLoadInfoName';
    StringField195.SetParentComponent(wdsContract);
    StringField195.Name := 'StringField195';
    StringField195.FieldName := 'CommodityName';
    StringField196.SetParentComponent(wdsContract);
    StringField196.Name := 'StringField196';
    StringField196.FieldName := 'PayTermsName';
    StringField197.SetParentComponent(wdsContract);
    StringField197.Name := 'StringField197';
    StringField197.FieldName := 'CONTROLLERName';
    StringField198.SetParentComponent(wdsContract);
    StringField198.Name := 'StringField198';
    StringField198.FieldName := 'CutOffPeriodDesc1';
    IntegerField63.SetParentComponent(wdsContract);
    IntegerField63.Name := 'IntegerField63';
    IntegerField63.FieldName := 'cutoff';
    StringField199.SetParentComponent(wdsContract);
    StringField199.Name := 'StringField199';
    StringField199.FieldName := 'CutOffPeriodDesc2';
    wcContract.SetParentComponent(Self);
    wcContract.Name := 'wcContract';
    wcContract.Connection := dmData.dbConnect;
    wcContract.Left := 112;
    wcContract.Top := 32;
    dsContracts.SetParentComponent(Self);
    dsContracts.Name := 'dsContracts';
    dsContracts.DataSet := wdsDisplay;
    dsContracts.Left := 256;
    dsContracts.Top := 32;
    wdsInsertImportSetup.SetParentComponent(Self);
    wdsInsertImportSetup.Name := 'wdsInsertImportSetup';
    wdsInsertImportSetup.Left := 584;
    wdsInsertImportSetup.Top := 362;
    wdsInsertImportSetupAUTONO.SetParentComponent(wdsInsertImportSetup);
    wdsInsertImportSetupAUTONO.Name := 'wdsInsertImportSetupAUTONO';
    wdsInsertImportSetupAUTONO.FieldName := 'AUTONO';
    wdsInsertImportSetupCONTRACTNO.SetParentComponent(wdsInsertImportSetup);
    wdsInsertImportSetupCONTRACTNO.Name := 'wdsInsertImportSetupCONTRACTNO';
    wdsInsertImportSetupCONTRACTNO.FieldName := 'CONTRACTNO';
    wdsInsertImportSetupSORTORDER.SetParentComponent(wdsInsertImportSetup);
    wdsInsertImportSetupSORTORDER.Name := 'wdsInsertImportSetupSORTORDER';
    wdsInsertImportSetupSORTORDER.FieldName := 'SORTORDER';
    wdsInsertImportSetupCOLNO.SetParentComponent(wdsInsertImportSetup);
    wdsInsertImportSetupCOLNO.Name := 'wdsInsertImportSetupCOLNO';
    wdsInsertImportSetupCOLNO.FieldName := 'COLNO';
    wdsInsertImportSetupFIELDNAME.SetParentComponent(wdsInsertImportSetup);
    wdsInsertImportSetupFIELDNAME.Name := 'wdsInsertImportSetupFIELDNAME';
    wdsInsertImportSetupFIELDNAME.FieldName := 'FIELDNAME';
    wdsInsertImportSetupFIELDTYPE.SetParentComponent(wdsInsertImportSetup);
    wdsInsertImportSetupFIELDTYPE.Name := 'wdsInsertImportSetupFIELDTYPE';
    wdsInsertImportSetupFIELDTYPE.FieldName := 'FIELDTYPE';
    wdsInsertImportSetupFORMATDISPLAY.SetParentComponent(wdsInsertImportSetup);
    wdsInsertImportSetupFORMATDISPLAY.Name := 'wdsInsertImportSetupFORMATDISPLAY';
    wdsInsertImportSetupFORMATDISPLAY.FieldName := 'FORMATDISPLAY';
    wdsInsertImportSetupSTARTCOPY.SetParentComponent(wdsInsertImportSetup);
    wdsInsertImportSetupSTARTCOPY.Name := 'wdsInsertImportSetupSTARTCOPY';
    wdsInsertImportSetupSTARTCOPY.FieldName := 'STARTCOPY';
    wdsInsertImportSetupENDCOPY.SetParentComponent(wdsInsertImportSetup);
    wdsInsertImportSetupENDCOPY.Name := 'wdsInsertImportSetupENDCOPY';
    wdsInsertImportSetupENDCOPY.FieldName := 'ENDCOPY';
    wdsInsertImportSetupCHAREND.SetParentComponent(wdsInsertImportSetup);
    wdsInsertImportSetupCHAREND.Name := 'wdsInsertImportSetupCHAREND';
    wdsInsertImportSetupCHAREND.FieldName := 'CHAREND';
    wdsInsertImportSetupIMPORTTYPE.SetParentComponent(wdsInsertImportSetup);
    wdsInsertImportSetupIMPORTTYPE.Name := 'wdsInsertImportSetupIMPORTTYPE';
    wdsInsertImportSetupIMPORTTYPE.FieldName := 'IMPORTTYPE';
    wdsInsertImportSetupDEB_CODE.SetParentComponent(wdsInsertImportSetup);
    wdsInsertImportSetupDEB_CODE.Name := 'wdsInsertImportSetupDEB_CODE';
    wdsInsertImportSetupDEB_CODE.FieldName := 'DEB_CODE';
    wdsInsertImportSetupIMPORTTYPEREC.SetParentComponent(wdsInsertImportSetup);
    wdsInsertImportSetupIMPORTTYPEREC.Name := 'wdsInsertImportSetupIMPORTTYPEREC';
    wdsInsertImportSetupIMPORTTYPEREC.FieldName := 'IMPORTTYPEREC';
  finally
    WebPanel6.AfterLoadDFMValues;
    WebPanel18.AfterLoadDFMValues;
    WebGroupBox8.AfterLoadDFMValues;
    WebDBLabel1.AfterLoadDFMValues;
    WebDBLabel2.AfterLoadDFMValues;
    WebLabel45.AfterLoadDFMValues;
    edtTemp.AfterLoadDFMValues;
    WebButton37.AfterLoadDFMValues;
    WebGroupBox9.AfterLoadDFMValues;
    WebLabel43.AfterLoadDFMValues;
    WebLabel44.AfterLoadDFMValues;
    WebButton38.AfterLoadDFMValues;
    WebDBEdit55.AfterLoadDFMValues;
    WebDBEdit56.AfterLoadDFMValues;
    WebButton40.AfterLoadDFMValues;
    WebButton41.AfterLoadDFMValues;
    WebFilePicker1.AfterLoadDFMValues;
    WebStringGrid1.AfterLoadDFMValues;
    WebPanel19.AfterLoadDFMValues;
    WebLabel46.AfterLoadDFMValues;
    WebLabel47.AfterLoadDFMValues;
    WebLabel48.AfterLoadDFMValues;
    WebLabel49.AfterLoadDFMValues;
    WebLabel50.AfterLoadDFMValues;
    WebLabel51.AfterLoadDFMValues;
    WebLabel52.AfterLoadDFMValues;
    WebLabel53.AfterLoadDFMValues;
    edtSortOrder.AfterLoadDFMValues;
    edtColumnNo.AfterLoadDFMValues;
    edtDisplayFormat.AfterLoadDFMValues;
    edtStartCopy.AfterLoadDFMValues;
    edtEndCopy.AfterLoadDFMValues;
    edtCharEnding.AfterLoadDFMValues;
    edtFieldName.AfterLoadDFMValues;
    WebPanel20.AfterLoadDFMValues;
    TMSFNCDataGrid2.AfterLoadDFMValues;
    dgdbaImportSetup.AfterLoadDFMValues;
    btnFirst.AfterLoadDFMValues;
    btnPrior.AfterLoadDFMValues;
    btnNext.AfterLoadDFMValues;
    btnLast.AfterLoadDFMValues;
    btnInsert.AfterLoadDFMValues;
    btnSearchFieldName.AfterLoadDFMValues;
    btnSaveSetup.AfterLoadDFMValues;
    btnCancelSetup.AfterLoadDFMValues;
    cbbDataType.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    wcImportSetup.AfterLoadDFMValues;
    wdsImportSetup.AfterLoadDFMValues;
    wdsImportSetupAUTONO.AfterLoadDFMValues;
    wdsImportSetupCONTRACTNO.AfterLoadDFMValues;
    wdsImportSetupSORTORDER.AfterLoadDFMValues;
    wdsImportSetupCOLNO.AfterLoadDFMValues;
    wdsImportSetupFIELDNAME.AfterLoadDFMValues;
    wdsImportSetupFIELDTYPE.AfterLoadDFMValues;
    wdsImportSetupFORMATDISPLAY.AfterLoadDFMValues;
    wdsImportSetupSTARTCOPY.AfterLoadDFMValues;
    wdsImportSetupENDCOPY.AfterLoadDFMValues;
    wdsImportSetupCHAREND.AfterLoadDFMValues;
    wdsImportSetupIMPORTTYPE.AfterLoadDFMValues;
    wdsImportSetupDEB_CODE.AfterLoadDFMValues;
    wdsImportSetupIMPORTTYPEREC.AfterLoadDFMValues;
    dsImportSetup.AfterLoadDFMValues;
    wdsDisplay.AfterLoadDFMValues;
    wdsDisplayDEB_NAME.AfterLoadDFMValues;
    wdsDisplayCONTRACTNAME.AfterLoadDFMValues;
    dsDisplay.AfterLoadDFMValues;
    wcDisplay.AfterLoadDFMValues;
    WebXLSX1.AfterLoadDFMValues;
    dsInsertImportSetup.AfterLoadDFMValues;
    wdsContract.AfterLoadDFMValues;
    IntegerField32.AfterLoadDFMValues;
    StringField94.AfterLoadDFMValues;
    StringField95.AfterLoadDFMValues;
    IntegerField33.AfterLoadDFMValues;
    IntegerField34.AfterLoadDFMValues;
    IntegerField35.AfterLoadDFMValues;
    IntegerField36.AfterLoadDFMValues;
    IntegerField37.AfterLoadDFMValues;
    IntegerField38.AfterLoadDFMValues;
    IntegerField39.AfterLoadDFMValues;
    IntegerField40.AfterLoadDFMValues;
    IntegerField41.AfterLoadDFMValues;
    StringField96.AfterLoadDFMValues;
    StringField97.AfterLoadDFMValues;
    FloatField17.AfterLoadDFMValues;
    FloatField18.AfterLoadDFMValues;
    FloatField19.AfterLoadDFMValues;
    FloatField20.AfterLoadDFMValues;
    FloatField21.AfterLoadDFMValues;
    StringField98.AfterLoadDFMValues;
    StringField99.AfterLoadDFMValues;
    FloatField22.AfterLoadDFMValues;
    IntegerField42.AfterLoadDFMValues;
    IntegerField43.AfterLoadDFMValues;
    IntegerField44.AfterLoadDFMValues;
    IntegerField45.AfterLoadDFMValues;
    IntegerField46.AfterLoadDFMValues;
    IntegerField47.AfterLoadDFMValues;
    IntegerField48.AfterLoadDFMValues;
    StringField100.AfterLoadDFMValues;
    StringField101.AfterLoadDFMValues;
    StringField102.AfterLoadDFMValues;
    StringField103.AfterLoadDFMValues;
    StringField104.AfterLoadDFMValues;
    StringField105.AfterLoadDFMValues;
    StringField106.AfterLoadDFMValues;
    StringField107.AfterLoadDFMValues;
    StringField108.AfterLoadDFMValues;
    FloatField23.AfterLoadDFMValues;
    SmallintField4.AfterLoadDFMValues;
    SmallintField5.AfterLoadDFMValues;
    IntegerField49.AfterLoadDFMValues;
    SmallintField6.AfterLoadDFMValues;
    IntegerField50.AfterLoadDFMValues;
    StringField109.AfterLoadDFMValues;
    StringField110.AfterLoadDFMValues;
    StringField111.AfterLoadDFMValues;
    StringField112.AfterLoadDFMValues;
    StringField113.AfterLoadDFMValues;
    StringField114.AfterLoadDFMValues;
    StringField115.AfterLoadDFMValues;
    StringField116.AfterLoadDFMValues;
    StringField117.AfterLoadDFMValues;
    StringField118.AfterLoadDFMValues;
    IntegerField51.AfterLoadDFMValues;
    StringField119.AfterLoadDFMValues;
    IntegerField52.AfterLoadDFMValues;
    FloatField24.AfterLoadDFMValues;
    StringField120.AfterLoadDFMValues;
    StringField121.AfterLoadDFMValues;
    StringField122.AfterLoadDFMValues;
    StringField123.AfterLoadDFMValues;
    StringField124.AfterLoadDFMValues;
    StringField125.AfterLoadDFMValues;
    StringField126.AfterLoadDFMValues;
    StringField127.AfterLoadDFMValues;
    StringField128.AfterLoadDFMValues;
    IntegerField53.AfterLoadDFMValues;
    StringField129.AfterLoadDFMValues;
    StringField130.AfterLoadDFMValues;
    StringField131.AfterLoadDFMValues;
    StringField132.AfterLoadDFMValues;
    StringField133.AfterLoadDFMValues;
    StringField134.AfterLoadDFMValues;
    StringField135.AfterLoadDFMValues;
    StringField136.AfterLoadDFMValues;
    IntegerField54.AfterLoadDFMValues;
    StringField137.AfterLoadDFMValues;
    StringField138.AfterLoadDFMValues;
    StringField139.AfterLoadDFMValues;
    StringField140.AfterLoadDFMValues;
    StringField141.AfterLoadDFMValues;
    StringField142.AfterLoadDFMValues;
    StringField143.AfterLoadDFMValues;
    FloatField25.AfterLoadDFMValues;
    StringField144.AfterLoadDFMValues;
    StringField145.AfterLoadDFMValues;
    StringField146.AfterLoadDFMValues;
    StringField147.AfterLoadDFMValues;
    StringField148.AfterLoadDFMValues;
    TimeField2.AfterLoadDFMValues;
    IntegerField55.AfterLoadDFMValues;
    IntegerField56.AfterLoadDFMValues;
    IntegerField57.AfterLoadDFMValues;
    DateField4.AfterLoadDFMValues;
    DateField5.AfterLoadDFMValues;
    DateField6.AfterLoadDFMValues;
    StringField149.AfterLoadDFMValues;
    StringField150.AfterLoadDFMValues;
    StringField151.AfterLoadDFMValues;
    FloatField26.AfterLoadDFMValues;
    FloatField27.AfterLoadDFMValues;
    FloatField28.AfterLoadDFMValues;
    FloatField29.AfterLoadDFMValues;
    StringField152.AfterLoadDFMValues;
    StringField153.AfterLoadDFMValues;
    StringField154.AfterLoadDFMValues;
    StringField155.AfterLoadDFMValues;
    StringField156.AfterLoadDFMValues;
    StringField157.AfterLoadDFMValues;
    StringField158.AfterLoadDFMValues;
    StringField159.AfterLoadDFMValues;
    FloatField30.AfterLoadDFMValues;
    StringField160.AfterLoadDFMValues;
    StringField161.AfterLoadDFMValues;
    StringField162.AfterLoadDFMValues;
    StringField163.AfterLoadDFMValues;
    StringField164.AfterLoadDFMValues;
    FloatField31.AfterLoadDFMValues;
    StringField165.AfterLoadDFMValues;
    StringField166.AfterLoadDFMValues;
    StringField167.AfterLoadDFMValues;
    StringField168.AfterLoadDFMValues;
    StringField169.AfterLoadDFMValues;
    StringField170.AfterLoadDFMValues;
    StringField171.AfterLoadDFMValues;
    IntegerField58.AfterLoadDFMValues;
    StringField172.AfterLoadDFMValues;
    StringField173.AfterLoadDFMValues;
    StringField174.AfterLoadDFMValues;
    StringField175.AfterLoadDFMValues;
    StringField176.AfterLoadDFMValues;
    IntegerField59.AfterLoadDFMValues;
    StringField177.AfterLoadDFMValues;
    StringField178.AfterLoadDFMValues;
    StringField179.AfterLoadDFMValues;
    StringField180.AfterLoadDFMValues;
    IntegerField60.AfterLoadDFMValues;
    StringField181.AfterLoadDFMValues;
    StringField182.AfterLoadDFMValues;
    StringField183.AfterLoadDFMValues;
    IntegerField61.AfterLoadDFMValues;
    StringField184.AfterLoadDFMValues;
    StringField185.AfterLoadDFMValues;
    IntegerField62.AfterLoadDFMValues;
    StringField186.AfterLoadDFMValues;
    FloatField32.AfterLoadDFMValues;
    StringField187.AfterLoadDFMValues;
    StringField188.AfterLoadDFMValues;
    StringField189.AfterLoadDFMValues;
    StringField190.AfterLoadDFMValues;
    StringField191.AfterLoadDFMValues;
    StringField192.AfterLoadDFMValues;
    StringField193.AfterLoadDFMValues;
    StringField194.AfterLoadDFMValues;
    StringField195.AfterLoadDFMValues;
    StringField196.AfterLoadDFMValues;
    StringField197.AfterLoadDFMValues;
    StringField198.AfterLoadDFMValues;
    IntegerField63.AfterLoadDFMValues;
    StringField199.AfterLoadDFMValues;
    wcContract.AfterLoadDFMValues;
    dsContracts.AfterLoadDFMValues;
    wdsInsertImportSetup.AfterLoadDFMValues;
    wdsInsertImportSetupAUTONO.AfterLoadDFMValues;
    wdsInsertImportSetupCONTRACTNO.AfterLoadDFMValues;
    wdsInsertImportSetupSORTORDER.AfterLoadDFMValues;
    wdsInsertImportSetupCOLNO.AfterLoadDFMValues;
    wdsInsertImportSetupFIELDNAME.AfterLoadDFMValues;
    wdsInsertImportSetupFIELDTYPE.AfterLoadDFMValues;
    wdsInsertImportSetupFORMATDISPLAY.AfterLoadDFMValues;
    wdsInsertImportSetupSTARTCOPY.AfterLoadDFMValues;
    wdsInsertImportSetupENDCOPY.AfterLoadDFMValues;
    wdsInsertImportSetupCHAREND.AfterLoadDFMValues;
    wdsInsertImportSetupIMPORTTYPE.AfterLoadDFMValues;
    wdsInsertImportSetupDEB_CODE.AfterLoadDFMValues;
    wdsInsertImportSetupIMPORTTYPEREC.AfterLoadDFMValues;
  end;
end;

end.